<template>
	<main :class="(isMobile ? 'page menu-margin no-padding' : '')+' scroll-page-container scrolly-dialetti full-height'">
		<interface-menu v-if="isMobile" />
		<interface-menu v-else :show-parenthesis="false" >
			<div class="scrolly-stages-container ">
				<div class="scrolly-stages-dots">
					<svg></svg>
				</div>
				<div class="scrolly-stages-points stack-vertical" data-justify="spaced" data-align="center">
					<div v-for="(stage, i) in stages" class="scrolly-stage-spot-cont pointer" :data-stage-id="stage.id">
						<div class="scrolly-stage-spot"></div>
					</div>
				</div>
			</div>
		</interface-menu>
		<div class="stage-label stack-vertical small-radius extra-small-shadow">
			<!-- <p class="stage-label-text"></p> -->
		</div>
		<interface-progress-bar
			v-if="sections.length"
			:scrolly-name="scrollyName"
			:curr-stage-name="currStageName"
			:historical-moment="historicalMoment"
			:curr-stage-section-index="currStageSectionIndex"
			:curr-stage-num-sections="currStageNumSections"
		/>
		<interface-scrolly-intro-section
			:sections="sections"
			:scrolly="scrolly"
			@show-player="() => showPlayer = true"
			@go-back="goBack"
		/>
		<main :class="`page no-padding ${isMobile ? '' : 'menu-margin'} scroll-main-container`" :data-scrolly-id="scrolly.id" v-if="scrolly.id">
			<section class="scroll-container-window">
				<div class="scroll-container">
					<!-- FIST SECTION PLACEHOLDER -->
					<section v-if="!isMobile" class="section-cont relative scrolly-introduction" id="s1" style="height: 0;">
					</section>

					<section id="s1-00" v-for="section in sections.filter(el => el.id == 's1-00')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<div class="bg-blue-animated full-width full-height absolute" style="opacity: 0;"></div>
							<div class="section-animation-cont full-width full-height">
								<div class="stage-title stack-vertical">
									<base-icon name="detail" />
									<h1 class="stage-title-text capitalize-first">{{stages[1].name[$i18n.locale]}}</h1>
								</div>
							</div>
							<img decoding="async" :src="imageS1_00" class="section-side-media shadow-filter right bottom" style="position: absolute; top: 0; left: 0; height: 110vh; opacity: 0.3">
							<interface-section-content
								class="font-paragrafo"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="section-title-mobile-v">
									<div class="stage-title stack-vertical">
										<base-icon name="detail" />
										<h1 class="stage-title-text capitalize-first">{{stages[1].name[$i18n.locale]}}</h1>
									</div>
								</div>
								<img decoding="async" :src="imageS1_00" class="stage-title-img-1 shadow-filter artifact-mobile-image">
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<interface-section-content
									class="font-paragrafo"
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
							</div>
						</template>
						<div class="background-quote" style="z-index: 1;">
							<div class="quote stack-vertical" data-justify="start">
								<base-icon name="virgolette" style="position: absolute;"/>
								<div class="font-quote font-medium">{{section.steps[2].quote[$i18n.locale]}}</div>
								<div v-html="utils.markdownToHtml(section.steps[2].author[$i18n.locale])"></div>
							</div>
						</div>
					</section>

					<section id="s1-01" v-for="section in sections.filter(el => el.id == 's1-01')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<div class="section-animation-cont map-container">
								<div ref="mapSVG" v-html="mapSVG" />
								<interface-remarkable-point v-for="(rs, i) in section.remarkablePoints"
									class="remarkable-point-thin"
									position="bottom"
									style="pointer-events: none"
									:id="'s1-01-rp-' + i"
									:pos-x="rs.posX"
									:pos-y="rs.posY"
									:customLabelStyle="rs.customLabelStyle"
								>
									{{rs.caption[$i18n.locale]}}
								</interface-remarkable-point>
							</div>
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-map-container mobile-fullw">
									<div class="mobile-map" id="map-s1-01" v-html="mapSVG" />
									<base-button
										v-if="!maps['s1-01']?.navigating"
										type="variant3"
										:text="utils.capitalizeFirst($t('scrolly_button_naviga_mappa'))"
										@clicked="navigateMap('s1-01')"
									/>
									<div
										v-if="maps['s1-01']?.navigating"
										class="stack-vertical map-navigator extra-small-shadow"
										data-align="center"
										data-jutify="center"
									>
										<div v-if="maps['s1-01'].rp.text" v-html="maps['s1-01'].rp.caption[$i18n.locale]"></div>
										<div class="stack-horizontal map-navigator-selector" data-justify="spaced">
											<base-icon name="arrow-sm-left-1" @click="cycleMapMobile('s1-01', -1)"/>
											<div class="text" v-html="utils.markdownToHtml(maps['s1-01'].rp.text || maps['s1-01'].rp.caption[$i18n.locale])" />
											<base-icon name="arrow-sm-right-1" @click="cycleMapMobile('s1-01', 1)"/>
										</div>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
							</div>
						</template>
					</section>

					<section id="s1-03" v-for="section in sections.filter(el => el.id == 's1-03')" :class="`section-cont relative ${section.sectionStyle}`" :stylez="'background-color: '+section.backgroundColor+';'+`--scrolly-text-color: ${section.textColor}`">
						<template v-if="!isMobile">
							<div class="section-animation-cont full-width full-height relative">
								<img decoding="async" class="absolute sliding-image img-1a" :src="imageS1_03('1a')">
								<img decoding="async" class="absolute sliding-image img-1b" :src="imageS1_03('1b')">
								<img decoding="async" class="absolute sliding-image img-2a" :src="imageS1_03('2a')">
								<img decoding="async" class="absolute sliding-image img-2b" :src="imageS1_03('2b')">
								<img decoding="async" class="absolute sliding-image img-3"	:src="imageS1_03('3')">
								<img decoding="async" class="absolute sliding-image img-4a" :src="imageS1_03('4a')">
								<img decoding="async" class="absolute sliding-image img-4b" :src="imageS1_03('4b')">
								<div class="background-gradient"></div>
							</div>
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-remarkable-point v-for="rs in section.remarkablePoints"
								position="bottom"
								:pos-x="rs.posX"
								:pos-y="rs.posY"
								:caption="rs.caption"
								:textBefore="rs.textBefore"
								:customLabelStyle="rs.customLabelStyle"
								wrap usemd
							/>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium"><p class="capitalize-first">{{section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale]}}</p></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="section-animation-cont artifact-mobile-image relative" style="margin: 0 -2em">
									<img decoding="async" class="sliding-image mobile" :src="imageS1_03('1a')">
									<img decoding="async" class="absolute sliding-image mobile" :src="imageS1_03('1b')">
									<img decoding="async" class="absolute sliding-image mobile" :src="imageS1_03('2a')">
									<img decoding="async" class="absolute sliding-image mobile" :src="imageS1_03('2b')">
									<img decoding="async" class="absolute sliding-image mobile"	:src="imageS1_03('3')">
									<img decoding="async" class="absolute sliding-image mobile" :src="imageS1_03('4a')">
									<img decoding="async" class="absolute sliding-image mobile" :src="imageS1_03('4b')">
									<interface-remarkable-point v-for="rs in section.remarkablePoints"
										:rp="rs"
										:id="rs.id"
										:text-before="rs.textBefore"
										:caption="rs.caption"
										:pos-x="rs.posX"
										:pos-y="rs.posY"
										:position="rs.position"
										wrap usemd
										@click-rm="selectMobileRemarkablePoint"
									/>
								</div>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
							</div>
						</template>
					</section>

					<section id="s1-04" v-for="section in sections.filter(el => el.id == 's1-04')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<!-- <div v-html="imageS1_04" class="section-side-media right bottom" style="width: 45%; height: 100%; opacity: 0; transform: translate(var(--scrolly-w), calc(50vh - 50%)) rotate(0deg)"></div> -->
							<img :src="imageS1_04" class="section-side-media right bottom" style="max-width: var(--max-media-width); max-height: 85%; opacity: 0; transform: translate(var(--scrolly-w), calc(50vh - 50%)) rotate(0deg)"/>
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-anim">
									<img :src="imageS1_04" class="from-right artifact-mobile-image" />
								</div>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section id="s1-05" v-for="section in sections.filter(el => el.id == 's1-05')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<img decoding="async" :src="imageS1_05" class="section-side-media shadow-filter right" style="height: 65vh; width: var(--max-media-width-tight); object-fit: contain; transform: translate(var(--scrolly-w), calc(50vh - 50%))">
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-remarkable-point v-for="rs in section.remarkablePoints"
								position="bottom"
								:pos-x="rs.posX"
								:pos-y="rs.posY"
								:caption="rs.caption"
								:textBefore="rs.textBefore"
								:customLabelStyle="rs.customLabelStyle"
								wrap usemd
							/>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-anim">
									<img decoding="async" class="artifact-mobile-image from-right shadow-filter" :src="imageS1_05">
								</div>
								<interface-remarkable-point v-for="rs in section.remarkablePoints"
									:rp="rs"
									:id="rs.id"
									:text-before="rs.textBefore"
									:caption="rs.caption"
									pos-x="70%"
									pos-y="20vw"
									wrap usemd
									@click-rm="selectMobileRemarkablePoint"
								/>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section id="s1-06" v-for="section in sections.filter(el => el.id == 's1-06')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<img decoding="async" :src="imageS1_06" class="section-side-media shadow-filter right" style="height: 92vh; width: var(--max-media-width); object-fit: contain; transform: translate(calc(var(--scrolly-w) / 2 - 50%), calc(50vh - 50%)) scale(220%)">
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-remarkable-point v-for="rs in section.remarkablePoints"
								position="bottom"
								:pos-x="rs.posX"
								:pos-y="rs.posY"
								:caption="rs.caption"
								:textBefore="rs.textBefore"
								:customLabelStyle="rs.customLabelStyle"
								wrap usemd
							/>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-anim">
									<img decoding="async" class="artifact-mobile-image from-left shadow-filter" :src="imageS1_06">
								</div>
								<interface-remarkable-point v-for="rs in section.remarkablePoints"
									:rp="rs"
									:id="rs.id"
									:text-before="rs.textBefore"
									:caption="rs.caption"
									pos-x="70%"
									pos-y="20vw"
									wrap usemd
									@click-rm="selectMobileRemarkablePoint"
								/>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section id="s1-07" v-for="section in sections.filter(el => el.id == 's1-07')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<div class="section-side-media right relative" style="width: calc(var(--max-media-width) - 4rem); height: 80vh; transform: translate(var(--scrolly-w), calc(50vh - 50%));">
								<img decoding="async" :src="imageS1_07[0]" class="img-1 shadow-filter" style="position: absolute; left: 0; top: 0; right: 0; bottom: 0; object-fit: contain; width: 100%; height: 100%; transform-origin: 39% 136%;"/>
								<img decoding="async" :src="imageS1_07[1]" class="shadow-filter" style="position: absolute; left: 0; top: 0; right: 0; bottom: 0; object-fit: contain; width: 100%; height: 100%;"/>
							</div>
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-remarkable-point v-for="rs in section.remarkablePoints"
								position="left"
								:pos-x="rs.posX"
								:pos-y="rs.posY"
								:caption="rs.caption"
								:textBefore="rs.textBefore"
								:customLabelStyle="rs.customLabelStyle"
								wrap usemd
							/>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-anim">
									<img decoding="async" class="artifact-mobile-image from-right shadow-filter" :src="imageS1_07[0]">
								</div>
								<interface-remarkable-point v-for="rs in section.remarkablePoints"
									:rp="rs"
									:id="rs.id"
									:text-before="rs.textBefore"
									:caption="rs.caption"
									pos-x="70%"
									pos-y="100vw"
									wrap usemd
									@click-rm="selectMobileRemarkablePoint"
								/>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section id="s1-08" v-for="section in sections.filter(el => el.id == 's1-08')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<img decoding="async" :src="backgroundS1_08" class="background-img">
							<div v-html="imageS1_08" class="section-side-media shadow-filter right bottom" style="width: var(--max-media-width); opacity: 0; transform: translate(calc(var(--scrolly-w) - 100% - var(--section-right-margin)), calc(100vh - 50%)) rotate(-35deg)"></div>
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-remarkable-point v-for="rs in section.remarkablePoints"
								position="left"
								:pos-x="rs.posX"
								:pos-y="rs.posY"
								:caption="rs.caption"
								:textBefore="rs.textBefore"
								:customLabelStyle="rs.customLabelStyle"
								wrap usemd
							/>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-anim">
									<div v-html="imageS1_08" class="artifact-mobile-image from-left"></div>
								</div>
								<interface-remarkable-point v-for="rs in section.remarkablePoints"
									:rp="rs"
									:id="rs.id"
									:text-before="rs.textBefore"
									:caption="rs.caption"
									pos-x="80%"
									pos-y="5vw"
									wrap usemd
									@click-rm="selectMobileRemarkablePoint"
								/>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section id="s1-09" v-for="section in sections.filter(el => el.id == 's1-09')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<img decoding="async" :src="imageS1_09" class="section-side-media shadow-filter right" style="width: var(--max-media-width); height: 80vh; object-fit: contain; transform: translate(var(--scrolly-w), calc(50vh - 50%)) rotate(140deg)">
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-remarkable-point v-for="rs in section.remarkablePoints"
								position="left"
								:pos-x="rs.posX"
								:pos-y="rs.posY"
								:caption="rs.caption"
								:textBefore="rs.textBefore"
								:customLabelStyle="rs.customLabelStyle"
								wrap usemd
							/>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
							<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
								<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
								<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-anim">
									<img decoding="async" class="artifact-mobile-image shadow-filter roll-in" :src="imageS1_09">
								</div>
								<interface-remarkable-point v-for="rs in section.remarkablePoints"
									:rp="rs"
									:id="rs.id"
									:text-before="rs.textBefore"
									:caption="rs.caption"
									pos-x="74%"
									pos-y="17vw"
									wrap usemd
									@click-rm="selectMobileRemarkablePoint"
								/>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>
					<section id="s1-game" v-for="section in sections.filter(el => el.id == 's1-game')" class="section-cont relative bg-red" style="padding-bottom: 0;">
						<view-game
							class="more-responsive"
							@lock="setInhibitScroll"
							@unlock="resetInhibitScroll"
							:game-component="InterfaceTimeQuizGame"
							:game-contents="gameContentsTrivial"
							title="game_titolo_trivial"
						/>
					</section>

					<section :id="section.id" v-for="section in sections.filter(el => el.id == 's2-00')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<div class="bg-blue-animated full-width full-height absolute" style="opacity: 0;"></div>
							<div class="section-animation-cont full-width full-height">
								<div class="stage-title stack-vertical">
									<base-icon name="detail" />
									<h1 class="stage-title-text capitalize-first">{{stages[2].name[$i18n.locale]}}</h1>
								</div>
							</div>
							<interface-section-content
								class="font-paragrafo"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium"><p class="capitalize-first">{{section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale]}}</p></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="section-title-mobile-v">
									<div class="stage-title stack-vertical">
										<base-icon name="detail" />
										<h1 class="stage-title-text capitalize-first">{{stages[2].name[$i18n.locale]}}</h1>
									</div>
								</div>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									class="font-paragrafo"
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
							</div>
						</template>
					</section>

					<section :id="section.id" v-for="section in sections.filter(el => el.id == 's2-02')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<div class="section-animation-cont map-container">
								<div ref="mapSVG" class="map-container-s2-02a" v-html="imageS2_02a" />
								<div ref="mapSVG" class="map-container-s2-02b" v-html="imageS2_02b" style="opacity: 0; pointer-events: none;" />
								<interface-remarkable-point v-for="(rs, i) in section.remarkablePoints"
									position="bottom"
									:class="`remarkable-point-thin ${rs.map}`"
									:id="'s2-02-rp-' + i"
									:pos-x="rs.posX"
									:pos-y="rs.posY"
									customLabelStyle="white-space: nowrap"
									force-zindex
								>
									{{rs.caption[$i18n.locale]}}
								</interface-remarkable-point>
							</div>
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium"><p class="capitalize-first">{{section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale]}}</p></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-map-container mobile-fullw">
									<div class="mobile-map" id="map-s2-02a" v-html="imageS2_02a" />
									<base-button
										v-if="!maps['s2-02a']?.navigating"
										type="variant3"
										:text="utils.capitalizeFirst($t('scrolly_button_naviga_mappa'))"
										@clicked="navigateMap('s2-02a')"
									/>
									<div
										v-if="maps['s2-02a']?.navigating"
										class="stack-vertical map-navigator extra-small-shadow"
										data-align="center"
										data-jutify="center"
									>
										<div v-if="maps['s2-02a'].rp.text" v-html="maps['s2-02a'].rp.caption[$i18n.locale]"></div>
										<div class="stack-horizontal map-navigator-selector" data-justify="spaced">
											<base-icon name="arrow-sm-left-1" @click="cycleMapMobile('s2-02a', -1)"/>
											<div class="text" v-html="utils.markdownToHtml(maps['s2-02a'].rp.text || maps['s2-02a'].rp.caption[$i18n.locale])" />
											<base-icon name="arrow-sm-right-1" @click="cycleMapMobile('s2-02a', 1)"/>
										</div>
									</div>
								</div>
								<div class="mobile-map-container mobile-fullw">
									<div class="mobile-map" id="map-s2-02b" v-html="imageS2_02b" />
									<base-button
										v-if="!maps['s2-02b']?.navigating"
										type="variant3"
										:text="utils.capitalizeFirst($t('scrolly_button_naviga_mappa'))"
										@clicked="navigateMap('s2-02b')"
									/>
									<div
										v-if="maps['s2-02b']?.navigating"
										class="stack-vertical map-navigator extra-small-shadow"
										data-align="center"
										data-jutify="center"
									>
										<div v-if="maps['s2-02b'].rp.text" v-html="maps['s2-02b'].rp.caption"></div>
										<div class="stack-horizontal map-navigator-selector" data-justify="spaced">
											<base-icon name="arrow-sm-left-1" @click="cycleMapMobile('s2-02b', -1)"/>
											<div class="text" v-html="utils.markdownToHtml(maps['s2-02b'].rp.text || maps['s2-02b'].rp.caption[$i18n.locale])" />
											<base-icon name="arrow-sm-right-1" @click="cycleMapMobile('s2-02b', 1)"/>
										</div>
									</div>
								</div>
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
							</div>
						</template>
					</section>

					<section :id="section.id" v-for="section in sections.filter(el => el.id == 's2-04')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<div class="map-container">
								<div ref="mapSVG" class="map-container-s2-04" v-html="imageS2_03" />
								<interface-remarkable-point v-for="(rs, i) in section.remarkablePoints"
									position="bottom"
									class="remarkable-point-thin"
									:id="'s2-04-rp-' + i"
									:pos-x="rs.posX"
									:pos-y="rs.posY"
									customLabelStyle="white-space: nowrap"
								>
									<span style="color: var(--color-dark-gray)">{{rs.caption[$i18n.locale]}}</span>
									<div v-html="utils.markdownToHtml(rs.text[$i18n.locale])" style="text-align: center"></div>
								</interface-remarkable-point>
							</div>
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium"><p class="capitalize-first">{{section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale]}}</p></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-map-container mobile-fullw">
									<div class="mobile-map" id="map-s2-04" v-html="imageS2_03" />
									<base-button
										v-if="!maps['s2-04']?.navigating"
										type="variant3"
										:text="utils.capitalizeFirst($t('scrolly_button_naviga_mappa'))"
										@clicked="navigateMap('s2-04')"
									/>
									<div
										v-if="maps['s2-04']?.navigating"
										class="stack-vertical map-navigator extra-small-shadow"
										data-align="center"
										data-jutify="center"
									>
										<div v-if="maps['s2-04'].rp.text" v-html="maps['s2-04'].rp.caption[$i18n.locale]"></div>
										<div class="stack-horizontal map-navigator-selector" data-justify="spaced">
											<base-icon name="arrow-sm-left-1" @click="cycleMapMobile('s2-04', -1)"/>
											<div class="text" v-html="utils.markdownToHtml(maps['s2-04'].rp.text[$i18n.locale] || maps['s2-04'].rp.caption[$i18n.locale])" />
											<base-icon name="arrow-sm-right-1" @click="cycleMapMobile('s2-04', 1)"/>
										</div>
									</div>
								</div>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
							</div>
						</template>
					</section>

					<section id="s3-00" v-for="section in sections.filter(el => el.id == 's3-00')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<div class="bg-blue-animated full-width full-height absolute" style="opacity: 0;"></div>
							<div class="images" style="opacity: 0.3">
							<img decoding="async" :src="imageS3_00[0]" class="section-side-media shadow-filter img-1 abs-top-left"
								style="transform: translate(calc(var(--scrolly-w) - 170%), calc(100vh - 50%)) rotate(-28deg); width: calc(0.45*var(--max-media-width-tight));">
							<img decoding="async" :src="imageS3_00[1]" class="section-side-media shadow-filter img-2 abs-top-left"
								style="transform: translate(calc(var(--scrolly-w) - 100%), calc(100vh - 40%)) rotate(-8deg); width: calc(0.45*var(--max-media-width-tight));">
							<img decoding="async" :src="imageS3_00[2]" class="section-side-media shadow-filter img-3 abs-top-left"
								style="transform: translate(calc(var(--scrolly-w) - 45%), calc(100vh - 65%)) rotate(-40deg); width: calc(0.45*var(--max-media-width-tight));">
							</div>
							<div class="section-animation-cont full-width full-height">
								<div class="stage-title stack-vertical">
									<base-icon name="detail" />
									<h1 class="stage-title-text capitalize-first">{{stages[3].name[$i18n.locale]}}</h1>
								</div>
							</div>
							<interface-section-content
								class="font-paragrafo"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
						</template>
						<template v-else>
							<img decoding="async" class="stage-title-background">
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="section-title-mobile-v">
									<div class="stage-title stack-vertical">
										<base-icon name="detail" />
										<h1 class="stage-title-text capitalize-first">{{stages[3].name[$i18n.locale]}}</h1>
									</div>
								</div>
								<div class="mobile-carousel stack-horizontal scrolly-mobile-full-width" style="margin-top: 0;">
									<img decoding="async" :src="imageS3_00[0]" class="section-side-media shadow-filter" />
									<img decoding="async" :src="imageS3_00[1]" class="section-side-media shadow-filter" />
									<img decoding="async" :src="imageS3_00[2]" class="section-side-media shadow-filter" />
								</div>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<interface-section-content
									class="font-paragrafo"
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
							</div>
						</template>
					</section>

					<section id="s3-02" v-for="section in sections.filter(el => el.id == 's3-02')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<div class="section-side-media absolute" style="transform: translate(calc(var(--ref-dim) * -0.3), calc(var(--ref-dim) * 0.3))">
								<div class="img-locandina absolute stack-vertical shadow-filter" style="width: calc(var(--ref-dim) * 0.37); transform: translate(calc(var(--ref-dim) * 0.044), calc(var(--ref-dim) * 0.033)) rotate(-10deg);">
									<img class="shadow-filter" decoding="async" :src="imageS3_02[0]">
								</div>
								<div class="img-tonino absolute stack-vertical shadow-filter" style="width: calc(var(--ref-dim) * 0.51); transform: translate(calc(var(--ref-dim) * 0.43), calc(var(--ref-dim) * 0.30)) rotate(15deg);">
									<img class="shadow-filter" decoding="async" :src="imageS3_02[1]">
								</div>
								<div class="img-targa absolute stack-vertical shadow-filter" style="width: calc(var(--ref-dim) * 0.40); transform: translate(calc(var(--ref-dim) * 0.024), calc(var(--ref-dim) * 0.56)) rotate(-6.7deg);">
									<img class="shadow-filter" decoding="async" :src="imageS3_02[2]" style="margin: -3% -4%"> <!-- crop image -->
								</div>
							</div>
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-artifact-info :artifact="artifacts[section.id+'-1']" class="artifact-1" position="right" />
							<interface-artifact-info :artifact="artifacts[section.id+'-2']" class="artifact-2" position="right" />
							<interface-artifact-info :artifact="artifacts[section.id+'-3']" class="artifact-3" position="right" />
							<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
								<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
								<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
							</div>
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium" v-html="utils.markdownToHtml(section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale])"></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-anim">
									<img decoding="async" class="from-left artifact-mobile-image" :src="imageS3_02[0]" style="--target-rot: -10deg">
									<interface-artifact-info :artifact="artifacts[section.id+'-1']" position="right" />
								</div>
								<div class="mobile-anim">
									<img decoding="async" class="from-right artifact-mobile-image" :src="imageS3_02[1]" style="--target-rot: 10deg">
									<interface-artifact-info :artifact="artifacts[section.id+'-2']" position="right" />
								</div>
								<div class="mobile-anim">
									<img decoding="async" class="from-left artifact-mobile-image" :src="imageS3_02[2]" style="--target-rot: -6deg">
									<interface-artifact-info :artifact="artifacts[section.id+'-3']" position="right" />
								</div>
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section id="s3-03" v-for="section in sections.filter(el => el.id == 's3-03')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<div class="section-side-media absolute" style="transform: translate(var(--scrolly-w), calc(50vh - 50%))">
								<video muted autoplay playsinline loop class="shadow-filter" style="width: var(--max-media-width)">
									<source v-if="media[section.id + '-webm']" :src="media[section.id + '-webm'].url" type="video/webm">
									<source v-if="media[section.id + '-mov']" :src="media[section.id + '-mov'].url" type="video/quicktime;codecs=hvc1">
									<source v-if="media[section.id + '-mp4']" :src="media[section.id + '-mp4'].url">
									<source v-if="media[section.id + '']" :src="media[section.id + ''].url">
								</video>
							</div>
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-remarkable-point v-for="rs in section.remarkablePoints"
								position="left"
								:pos-x="rs.posX"
								:pos-y="rs.posY"
								:caption="rs.caption"
								:textBefore="rs.textBefore"
								:customLabelStyle="rs.customLabelStyle"
								wrap usemd
							/>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium"><p class="capitalize-first">{{section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale]}}</p></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-anim mobile-fullw">
									<video muted autoplay playsinline loop class="shadow-filter from-right">
										<source v-if="media[section.id + '-webm']" :src="media[section.id + '-webm'].url+'#t=0.001'" type="video/webm">
										<source v-if="media[section.id + '-mov']" :src="media[section.id + '-mov'].url+'#t=0.001'" type="video/quicktime;codecs=hvc1">
										<source v-if="media[section.id + '-mp4']" :src="media[section.id + '-mp4'].url+'#t=0.001'">
										<source v-if="media[section.id + '']" :src="media[section.id + ''].url+'#t=0.001'">
									</video>
								</div>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section id="s3-04" v-for="section in sections.filter(el => el.id == 's3-04')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<div class="section-animation-cont full-width full-height relative">
								<div class="background-gradient"></div>
								<video class="background-video" muted autoplay playsinline loop>
									<source v-if="media[section.id + '-teaser-webm']" :src="media[section.id + '-teaser-webm'].url" type="video/webm">
									<source v-if="media[section.id + '-teaser-mov']" :src="media[section.id + '-teaser-mov'].url" type="video/quicktime;codecs=hvc1">
									<source v-if="media[section.id + '-teaser-mp4']" :src="media[section.id + '-teaser-mp4'].url">
									<source v-if="media[section.id + '-teaser']" :src="media[section.id + '-teaser'].url">
								</video>
							</div>
							<div class="scroll-content-section left">
								<div class="scroll-content-text stack-vertical small">
									<div class="stack-vertical" style="gap: inherit" v-html="utils.markdownToHtml(section.caption[$i18n.locale])"></div>
									<base-button
										type="variant7"
										icon="btn-play-1"
										:text="utils.capitalizeWords($t('scrolly_button_riproduci_filmato'))"
										@clicked="() => showVideo(getSources(media, section.id), media[`${section.id}-mp4`].subs)"
									/>
								</div>
							</div>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium"><p class="capitalize-first">{{section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale]}}</p></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical no-space">
								<video class="mobile-fullw" controls>
									<source v-if="media[section.id + '-webm']" :src="media[section.id + '-webm'].url+'#t=0.001'" type="video/webm">
									<source v-if="media[section.id + '-mov']" :src="media[section.id + '-mov'].url+'#t=0.001'" type="video/quicktime;codecs=hvc1">
									<source v-if="media[section.id + '-mp4']" :src="media[section.id + '-mp4'].url+'#t=0.001'">
									<source v-if="media[section.id + '']" :src="media[section.id + ''].url+'#t=0.001'">
								</video>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section id="s3-05" v-for="section in sections.filter(el => el.id == 's3-05')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<inhibit-scroll-container
								name="s3-05-dodici"
								ref="scrollS3_05Cont"
								:visible="currSection == section && currStepIndex == 0"
								@inhibit="inhibitScrollContainer"
								class="scrollable-cont dodici"
							>
									<img decoding="async" class="absolute shadow-filter dodici-image img-1" :src="imageS3_05Dodici[0]" style="transform-origin: 45% 3.2%">
									<img decoding="async" class="absolute shadow-filter dodici-image img-2" :src="imageS3_05Dodici[1]" style="transform-origin: 25.5% 23%">
									<img decoding="async" class="absolute shadow-filter dodici-image img-3" :src="imageS3_05Dodici[2]" style="transform-origin: 77% 24%">
									<img decoding="async" class="absolute shadow-filter dodici-image img-4" :src="imageS3_05Dodici[3]" style="transform-origin: 50% 51.5%">
									<img decoding="async" class="absolute shadow-filter dodici-image img-5" :src="imageS3_05Dodici[4]" style="transform-origin: 50% 73%">
									<img decoding="async" class="absolute shadow-filter dodici-image img-6" :src="imageS3_05Dodici[5]" style="transform-origin: 50% 92%">
							</inhibit-scroll-container>
							<inhibit-scroll-container
								name="s3-05-video"
								ref="scrollS3_05Cont"
								:visible="currSection == section && currStepIndex == 1"
								@inhibit="inhibitScrollContainer"
								@scrolled="scrollS2_05"
								class="scrollable-cont"
							>
								<div style="width: 100%; height: 200%;"></div>
								<img :src="imageS3_05Amica" class="amica full-width full-height"
									style="position: sticky; object-fit: cover; bottom: 0">
							</inhibit-scroll-container>
							<img decoding="async" class="absolute blinds" :src="imageS3_05Blinds" style="bottom: 100%">
							<div class="background-gradient" style="pointer-events: none"></div>
							<div class="scroll-content-section left">
								<div class="scroll-content-text stack-vertical small">
									<div class="stack-vertical" style="gap: inherit" v-html="utils.markdownToHtml(section.caption[$i18n.locale])"></div>
								</div>
							</div>
							<interface-remarkable-point v-for="rs in section.remarkablePoints"
								position="left"
								:pos-x="rs.posX"
								:pos-y="rs.posY"
								:caption="rs.caption"
								:textBefore="rs.textBefore"
								:customLabelStyle="rs.customLabelStyle"
								wrap usemd
							/>
							<interface-artifact-info :artifact="artifacts[section.id+'-1']" class="artifact-1" position="right" />
							<interface-artifact-info :artifact="artifacts[section.id+'-2']" class="artifact-2" position="right" />
							<interface-artifact-info :artifact="artifacts[section.id+'-3']" class="artifact-3" position="right" />
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium"><p class="capitalize-first">{{section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale]}}</p></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-anim">
									<img decoding="async" class="from-right artifact-mobile-image shadow-filter" :src="imageS3_05DodiciComplete">
									<interface-artifact-info :artifact="artifacts[section.id+'-1']" position="right" />
								</div>
								<div class="mobile-anim">
									<img decoding="async" class="from-left artifact-mobile-image" :src="imageS3_05Amica">
									<interface-artifact-info :artifact="artifacts[section.id+'-2']" position="right" />
								</div>
								<div class="mobile-anim">
									<div style="padding: 26% 0; overflow: hidden;" class="from-left artifact-mobile-image">
										<img decoding="async" style="transform: translateX(-50%) scale(2)" :src="imageS3_05Blinds">
									</div>
									<interface-artifact-info :artifact="artifacts[section.id+'-3']" position="right" />
								</div>

								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section id="s3-06" v-for="section in sections.filter(el => el.id == 's3-06')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<img :src="imageS3_06" class="section-side-media shadow-filter right" style="width: var(--max-media-width); height: 100vh; object-fit: contain; transform: translate(var(--scrolly-w), calc(50vh - 50%))"/>
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium"><p class="capitalize-first">{{section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale]}}</p></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-anim">
									<img :src="imageS3_06" decoding="async" class="artifact-mobile-image shadow-filter from-right">
								</div>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section :id="section.id" v-for="section in sections.filter(el => el.id == 's4-00')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<div class="bg-blue-animated full-width full-height absolute" style="opacity: 0;"></div>
							<div class="section-animation-cont full-width full-height">
								<div class="stage-title stack-vertical">
									<base-icon name="detail" />
									<h1 class="stage-title-text capitalize-first">{{stages[4].name[$i18n.locale]}}</h1>
								</div>
							</div>
							<img decoding="async" :src="imageS4_00" class="section-side-media shadow-filter right bottom" style="position: absolute; top: 0; left: 0; width: calc(1.25*var(--max-media-width)); opacity: 0.3">
							<interface-section-content
								class="font-paragrafo"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium"><p class="capitalize-first">{{section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale]}}</p></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="section-title-mobile-v">
									<div class="stage-title stack-vertical">
										<base-icon name="detail" />
										<h1 class="stage-title-text capitalize-first">{{stages[4].name[$i18n.locale]}}</h1>
									</div>
								</div>
								<img decoding="async" class="artifact-mobile-image shadow-filter" :src="imageS4_00" style="transform: rotate(-5deg) scale(150%); margin: 20vw 0;">
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									class="font-paragrafo"
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
							</div>
						</template>
					</section>

					<section :id="section.id" v-for="section in sections.filter(el => el.id == 's4-02')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<div class="section-animation-cont" style="transform: translate(calc(var(--u) * 1), calc(var(--u) * 1)) rotate(-15deg)">
								<video playsinline controls class="shadow-filter check-subs" id="s4-02-1-video" style="opacity: 0.2; transform: translate(calc(var(--u) * 0.5), calc(var(--u) * 0.74)) rotate(-14.5deg)">
									<source v-if="media[section.id + '-1-webm']" :src="media[section.id + '-1-webm'].url" type="video/webm">
									<source v-if="media[section.id + '-1-mov']" :src="media[section.id + '-1-mov'].url" type="video/quicktime;codecs=hvc1">
									<source v-if="media[section.id + '-1-mp4']" :src="media[section.id + '-1-mp4'].url">
									<source v-if="media[section.id + '-1']" :src="media[section.id + '-1'].url">
								</video>
								<video playsinline controls class="shadow-filter check-subs" id="s4-02-2-video" style="opacity: 0.2; transform: translate(calc(var(--u) * 0.06), calc(var(--u) * 1.5)) rotate(15deg)">
									<source v-if="media[section.id + '-2-webm']" :src="media[section.id + '-2-webm'].url" type="video/webm">
									<source v-if="media[section.id + '-2-mov']" :src="media[section.id + '-2-mov'].url" type="video/quicktime;codecs=hvc1">
									<source v-if="media[section.id + '-2-mp4']" :src="media[section.id + '-2-mp4'].url">
									<source v-if="media[section.id + '-2']" :src="media[section.id + '-2'].url">
								</video>
							</div>
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-artifact-info :artifact="artifacts[section.id+'-1']" class="artifact-1" position="right" />
							<interface-artifact-info :artifact="artifacts[section.id+'-2']" class="artifact-2" position="right" />
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium" v-html="utils.markdownToHtml(section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale])"></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
							<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
								<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
								<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-anim">
									<video controls class="from-left shadow-filter white-border-thin small-rounded" id="s4-02-1-video" style="width: 100%; background: var(--color-white);">
										<source v-if="media[section.id + '-1-webm']" :src="media[section.id + '-1-webm'].url+'#t=0.001'" type="video/webm">
										<source v-if="media[section.id + '-1-mov']" :src="media[section.id + '-1-mov'].url+'#t=0.001'" type="video/quicktime;codecs=hvc1">
										<source v-if="media[section.id + '-1-mp4']" :src="media[section.id + '-1-mp4'].url+'#t=0.001'">
										<source v-if="media[section.id + '-1']" :src="media[section.id + '-1'].url+'#t=0.001'">
									</video>
								</div>
								<interface-artifact-info :artifact="artifacts[section.id+'-1']" position="right" />
								<div class="mobile-anim">
									<video controls class="from-right shadow-filter white-border-thin small-rounded" id="s4-02-2-video" style="width: 100%; background: var(--color-white);">
										<source v-if="media[section.id + '-2-webm']" :src="media[section.id + '-2-webm'].url+'#t=0.001'" type="video/webm">
										<source v-if="media[section.id + '-2-mov']" :src="media[section.id + '-2-mov'].url+'#t=0.001'" type="video/quicktime;codecs=hvc1">
										<source v-if="media[section.id + '-2-mp4']" :src="media[section.id + '-2-mp4'].url+'#t=0.001'">
										<source v-if="media[section.id + '-2']" :src="media[section.id + '-2'].url+'#t=0.001'">
									</video>
								</div>
								<interface-artifact-info :artifact="artifacts[section.id+'-2']" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section :id="section.id" v-for="section in sections.filter(el => el.id == 's4-03')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<div class="section-animation-cont" style="transform: translate(calc(var(--u) * 0.5), calc(var(--u)*1)); overflow: visible;">
								<img :src="imageS4_03[0]" class="shadow-filter" style="height: var(--u); opacity: 0.2; transform: translate(calc(var(--u) * 0.1), calc(var(--u) * 0.05)) rotate(10deg)" />
								<img :src="imageS4_03[1]" class="shadow-filter size-video" style="opacity: 0.2; transform: translate(calc(var(--u) * 0.1), calc(var(--u) * 1.2)) rotate(-20deg)" />
								<video playsinline controls class="shadow-filter check-subs" style="opacity: 0.2; background: var(--color-dark-gray); transform: translate(calc(var(--u) * 0.15), calc(var(--u) * 2)) rotate(-0.5deg)">
									<source v-if="media[section.id + '-3-webm']" :src="media[section.id + '-3-webm'].url" type="video/webm">
									<source v-if="media[section.id + '-3-mov']" :src="media[section.id + '-3-mov'].url" type="video/quicktime;codecs=hvc1">
									<source v-if="media[section.id + '-3-mp4']" :src="media[section.id + '-3-mp4'].url">
									<source v-if="media[section.id + '-3']" :src="media[section.id + '-3'].url">
								</video>
							</div>
							<interface-artifact-info :artifact="artifacts[section.id+'-1']" class="artifact-1" position="right" />
							<interface-artifact-info :artifact="artifacts[section.id+'-2']" class="artifact-2" position="right" />
							<interface-artifact-info :artifact="artifacts[section.id+'-3']" class="artifact-3" position="right" />
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium"><p class="capitalize-first">{{section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale]}}</p></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
							<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
								<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
								<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-anim">
									<img :src="imageS4_03[0]" class="from-left shadow-filter white-border-thin small-rounded" style="--target-rot: -4deg" />
								</div>
								<interface-artifact-info :artifact="artifacts[section.id+'-1']" position="right" />
								<div class="mobile-anim">
									<img :src="imageS4_03[1]" class="from-left shadow-filter white-border-thin small-rounded" style="--target-rot: 7deg" />
								</div>
								<interface-artifact-info :artifact="artifacts[section.id+'-2']" position="right" />
								<div class="mobile-anim">
									<video controls class="from-right shadow-filter white-border-thin small-rounded" style="background: var(--color-white); width: 100%;">
										<source v-if="media[section.id + '-3-webm']" :src="media[section.id + '-3-webm'].url+'#t=0.001'" type="video/webm">
										<source v-if="media[section.id + '-3-mov']" :src="media[section.id + '-3-mov'].url+'#t=0.001'" type="video/quicktime;codecs=hvc1">
										<source v-if="media[section.id + '-3-mp4']" :src="media[section.id + '-3-mp4'].url+'#t=0.001'">
										<source v-if="media[section.id + '-3']" :src="media[section.id + '-3'].url+'#t=0.001'">
									</video>
								</div>
								<interface-artifact-info :artifact="artifacts[section.id+'-3']" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section :id="section.id" v-for="section in sections.filter(el => el.id == 's4-04')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<div class="section-animation-cont">
								<img decoding="async" :src="imageS4_04.bg" class="bg" style="transform: translateY(-3%)">
								<img decoding="async" :src="imageS4_04.mid" class="mid">
								<img decoding="async" :src="imageS4_04.fg" class="fg" style="transform: translateY(6%)">
								<div class="background-gradient"></div>
							</div>
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium" v-html="utils.markdownToHtml(section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale])"></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
							<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
								<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
								<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical no-space">
								<div class="section-animation-cont-mobile mobile-fullw">
									<img decoding="async" :src="imageS4_04.bg" class="bg">
									<img decoding="async" :src="imageS4_04.mid" class="mid">
								</div>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section :id="section.id" v-for="section in sections.filter(el => el.id == 's4-05')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<div class="section-animation-cont full-width full-height relative">
								<div class="background-gradient"></div>
								<video class="background-video" muted autoplay playsinline loop>
									<source v-if="media[section.id + '-teaser-webm']" :src="media[section.id + '-teaser-webm'].url" type="video/webm">
									<source v-if="media[section.id + '-teaser-mov']" :src="media[section.id + '-teaser-mov'].url" type="video/quicktime;codecs=hvc1">
									<source v-if="media[section.id + '-teaser-mp4']" :src="media[section.id + '-teaser-mp4'].url">
									<source v-if="media[section.id + '-teaser']" :src="media[section.id + '-teaser'].url">
								</video>
							</div>
							<div class="scroll-content-section left">
								<div class="scroll-content-text stack-vertical small">
									<div class="stack-vertical" style="gap: inherit" v-html="utils.markdownToHtml(section.caption[$i18n.locale])"></div>
									<base-button
										type="variant7"
										icon="btn-play-1"
										:text="utils.capitalizeWords($t('scrolly_button_riproduci_filmato'))"
										@clicked="() => showVideo(getSources(media, section.id))"
									/>
								</div>
							</div>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium"><p class="capitalize-first">{{section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale]}}</p></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
							<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
								<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
								<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical no-space">
								<video class="mobile-fullw" controls>
									<source v-if="media[section.id + '-webm']" :src="media[section.id + '-webm'].url+'#t=0.001'" type="video/webm">
									<source v-if="media[section.id + '-mov']" :src="media[section.id + '-mov'].url+'#t=0.001'" type="video/quicktime;codecs=hvc1">
									<source v-if="media[section.id + '-mp4']" :src="media[section.id + '-mp4'].url+'#t=0.001'">
									<source v-if="media[section.id]" :src="media[section.id].url+'#t=0.001'">
								</video>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>
					<section id="s4-game" v-for="section in sections.filter(el => el.id == 's4-game')" :class="`section-cont relative ${this.isMobile ? 'bg-blue-paper' : 'bg-gold-game'}`" style="padding-bottom: 0;">
						<view-game
							class="more-responsive"
							@lock="setInhibitScroll"
							@unlock="resetInhibitScroll"
							:game-component="InterfaceIntruderGame"
							:game-contents="gameContentsIntruder"
							title="game_titolo_risposta_corretta"
							:description="$t('game_descrizione_risposta_corretta')"
						/>
					</section>

					<section :id="section.id" v-for="section in sections.filter(el => el.id == 's5-00')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<img class="section-side-media right bottom shadow-filter" :src="imageS5_00_full">
							<div class="background-gradient"></div>
							<div class="background-blue abs-fill-cover" style="background-color: var(--color-brand-blue); opacity: 0.5;"></div>
							<div class="stage-title stack-vertical">
								<base-icon name="detail" />
								<h1 class="stage-title-text capitalize-first">{{stages[5].name[$i18n.locale]}}</h1>
							</div>
							<interface-section-content
								class="font-paragrafo"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium"><p class="capitalize-first">{{section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale]}}</p></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="section-title-mobile-v">
									<div class="stage-title stack-vertical">
										<base-icon name="detail" />
										<h1 class="stage-title-text capitalize-first">{{stages[5].name[$i18n.locale]}}</h1>
									</div>
								</div>
								<div class="section-animation-cont-mobile mobile-fullw">
									<img decoding="async" :src="imageS5_00.bg" class="bg">
									<img decoding="async" :src="imageS5_00.fg" class="fg">
								</div>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									class="font-paragrafo"
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
							</div>
						</template>
					</section>

					<section :id="section.id" v-for="section in sections.filter(el => el.id == 's5-02')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<div class="map-container">
								<div ref="mapSVG" class="map-container-s5-02" v-html="imageS5_02" />
								<interface-remarkable-point v-for="(rs, i) in section.remarkablePoints"
									position="bottom"
									class="remarkable-point-thin"
									:id="'s5-02-rp-' + i"
									:pos-x="rs.posX"
									:pos-y="rs.posY"
									customLabelStyle="white-space: nowrap"
								>
									<span style="color: var(--color-dark-gray)">{{rs.caption[$i18n.locale]}}</span>
									<p style="text-align: center"><i>{{rs.text}}</i></p>
								</interface-remarkable-point>
							</div>
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium"><p class="capitalize-first">{{section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale]}}</p></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
							<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
								<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
								<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-map-container mobile-fullw">
									<div class="mobile-map" id="map-s5-02" v-html="imageS5_02" />
									<base-button
										v-if="!maps['s5-02']?.navigating"
										type="variant3"
										:text="utils.capitalizeFirst($t('scrolly_button_naviga_mappa'))"
										@clicked="navigateMap('s5-02')"
									/>
									<div
										v-if="maps['s5-02']?.navigating"
										class="stack-vertical map-navigator extra-small-shadow"
										data-align="center"
										data-jutify="center"
									>
										<div v-if="maps['s5-02'].rp.text" v-html="maps['s5-02'].rp.caption[$i18n.locale]"></div>
										<div class="stack-horizontal map-navigator-selector" data-justify="spaced">
											<base-icon name="arrow-sm-left-1" @click="cycleMapMobile('s5-02', -1)"/>
											<div class="text" v-html="utils.markdownToHtml(maps['s5-02'].rp.text || maps['s5-02'].rp.caption[$i18n.locale])" />
											<base-icon name="arrow-sm-right-1" @click="cycleMapMobile('s5-02', 1)"/>
										</div>
									</div>
								</div>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section :id="section.id" v-for="section in sections.filter(el => el.id == 's5-03')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<img decoding="async" :src="imageS5_03" class="section-side-media shadow-filter abs-top-left"
								style="width: var(--max-media-width); height: 85vh; object-fit: contain; transform: translate(calc(var(--scrolly-w) - 80%), calc(100vh + 5%)) rotate(-50deg);"
							>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium" v-html="utils.markdownToHtml(section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale])"></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
							<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
								<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
								<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-anim">
									<img decoding="async" class="from-right artifact-mobile-image mobile-fullw shadow-filter" :src="imageS5_03" style="--target-rot: -5deg">
								</div>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section :id="section.id" v-for="section in sections.filter(el => el.id == 's5-04')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<img decoding="async" :src="imageS5_04[0]" class="section-side-media shadow-filter img-3 abs-top-left"
								style="transform: translate(calc(var(--scrolly-w) + 25%), calc(50vh - 50%)) rotate(-40deg); width: calc(0.7 * var(--max-media-width));">
							<img decoding="async" :src="imageS5_04[1]" class="section-side-media shadow-filter img-2 abs-top-left"
								style="transform: translate(calc(var(--scrolly-w) * 0.6 - 50%), calc(100vh + 40%)) rotate(-8deg); width: calc(0.7 * var(--max-media-width));">
							<img decoding="async" :src="imageS5_04[2]" class="section-side-media shadow-filter img-1 abs-top-left"
								style="transform: translate(calc(var(--scrolly-w) * 0.25 - 50%), -150%) rotate(-15deg); width: calc(0.85 * var(--max-media-width));">
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium"><p class="capitalize-first">{{section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale]}}</p></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
							<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
								<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
								<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-anim artifact-mobile-image mobile-fullw" style="height: 180vw">
									<img decoding="async" :src="imageS5_04[0]" class="abs-top-left shadow-filter" style="transform: translate(calc(75vw - 50%), calc(90vw - 50%)) rotate(27deg)">
									<img decoding="async" :src="imageS5_04[2]" class="from-right abs-top-left shadow-filter" style="--target-trans: translate(calc(50vw - 65%), 5%); --target-rot: -8deg">
									<img decoding="async" :src="imageS5_04[1]" class="from-left abs-top-left shadow-filter" style="--target-trans: translate(calc(50vw - 55%), calc(180vw - 105%)); --target-rot: 4deg">
								</div>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section :id="section.id" v-for="section in sections.filter(el => el.id == 's5-05')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<img decoding="async" :src="imageS5_05" class="section-side-media shadow-filter abs-top-left"
								style="width: calc(0.85 * var(--max-media-width)); height: 150vh; object-fit: contain; transform: translate(calc(var(--scrolly-w) - 80%), calc(100vh + 4%)) rotate(-50deg);"
							>
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium"><p class="capitalize-first">{{section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale]}}</p></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
							<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
								<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
								<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-anim">
									<img decoding="async" class="from-right artifact-mobile-image shadow-filter" :src="imageS5_05" style="--target-rot: -3deg">
								</div>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section :id="section.id" v-for="section in sections.filter(el => el.id == 's5-06')" :class="`section-cont relative ${section.sectionStyle}`">
						<template v-if="!isMobile">
							<interface-section-content
								style="pointer-events: none;"
								:type="section.template"
								:id="section.id"
								:visible="false"
								:size-content-text="section.sizeContentText"
								:caption="section.caption[$i18n.locale]"
								:additional-style-section-content="section.additionalStyleSectionContent"
							/>
	.						<img decoding="async" :src="imageS5_06" class="section-side-media right shadow-filter white-border-thick" style="max-height: 80vh; max-width: var(--max-media-width); transform: translate(calc(var(--scrolly-w) + 50%), calc(50vh - 50%)) rotate(10deg)">
							<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
							<div v-if="section.inDepthItem !== undefined" :class="'stack-horizontal scroll-content-section-button pointer '+section.buttonPosition" @click="showInDepth(section.id)">
								<base-icon name="left-parenthesis"/>
								<div class="section-button-text stack-vertical" data-align="center">
									<div class="font-caption-maiusc-2">{{$t('scrolly_approfondimento').toUpperCase()}}</div>
									<div class="font-caption-medium"><p class="capitalize-first">{{section.inDepthItem.text.title[$i18n.locale] + ' ' + section.inDepthItem.text.subtitle[$i18n.locale]}}</p></div>
								</div>
								<base-icon name="right-parenthesis"/>
							</div>
							<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
								<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
								<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
							</div>
						</template>
						<template v-else>
							<div class="scrolly-section-mobile-cont stack-vertical">
								<div class="mobile-anim">
									<img decoding="async" class="from-left artifact-mobile-image shadow-filter white-border-thin small-rounded" :src="imageS5_06" style="--target-rot: -5deg">
								</div>
								<interface-artifact-info :artifact="artifacts[section.id]" position="right" />
								<div v-if="section.inDepthItem !== undefined" class="grid-horizontal in-depth-mobile-button lateral-bouncing" @click="showInDepth(section.id)">
									<base-icon name="left-parenthesis" class="in-depth-mobile-parenthesis"/>
									<div class="in-depth-mobile-cont">
										<base-icon name="question-mark" class="in-depth-question-mark"/>
									</div>
								</div>
								<interface-section-content
									:type="section.template"
									:id="section.id"
									:visible="false"
									:size-content-text="section.sizeContentText"
									:remarkable-points="section.remarkablePoints"
									:caption="section.caption[$i18n.locale]"
									:additional-style-section-content="section.additionalStyleSectionContent"
								/>
								<div v-if="section.curiosity" class="scrolly-content-curiosity stack-vertical small-rounded extra-small-shadow curiosity-left">
									<div class="font-medium capitalize-first">{{$t('scrolly_curiosità')}}</div>
									<div class="font-caption" v-html="utils.markdownToHtml(section.curiosity[$i18n.locale])"></div>
								</div>
							</div>
						</template>
					</section>

					<section id="s5-game" v-for="section in sections.filter(el => el.id == 's5-game')" class="section-cont relative bg-red" style="padding-bottom: 0;">
						<view-game
							@lock="setInhibitScroll"
							@unlock="resetInhibitScroll"
							:game-component="InterfaceQuoteGame"
							:game-contents="gameContents.quote"
							title="game_titolo_magnetiche"
						/>
					</section>

					<!-- BIBLIOGRAPHY -->
					<interface-scrolly-bibliography-section
						:final-section="sections[sections.length-1]"
						:stages="stages"
					/>
				</div>
			</section>

		</main>
		<interface-audio-player
			:title="scrollyName"
			:visible="showPlayer"
			@exit-player="() => showPlayer = false"
			:stages="stages"
			:scrolly-id="scrolly.id"
			:media="media"
		/>
		<interface-video-player
			v-if="currentVideo"
			:visible="currentVideo.visible"
			:sources="currentVideo.sources"
			:subs-video="currentVideo.srts"
			@close-video="closeVideo"
		/>
		<interface-in-depth
			v-if="currentInDepth"
			:visible="currentInDepth.visible"
			:section-id="currentInDepth.idSection"
			:title="currentInDepth.text.title[$i18n.locale]"
			:subtitle="currentInDepth.text.subtitle[$i18n.locale]"
			:contents="currentInDepth.contents"
			@close-in-depth="closeInDepth(currentInDepth.idSection)"
		/>
		<scroll-events
			v-if="!isMobile"
			:inhibit="inhibitScroll"
			scroll-container-selector="scroll-container"
			@scroll-event="scrollEventHandler"
		/>
		<div :class="'sc-artifact-modal-cont '+(artifactModalVisible ? 'visible' : '')+' '+modalArtifactMode" @click="closeArtifactModal">
			<div class="sc-artifact-modal stack-horizontal small-radius">
				<base-icon v-if="!isMobile" name="e-remove-2" class="pointer sc-exit-icon" @click="closeArtifactModal"/>
				<base-button-rounded v-if="isMobile" icon="e-remove-2" color="var(--color-gold)" class="sc-mobile-exit-icon" icon-color="var(--color-black)" @button-clicked="closeArtifactModal" />
				<div v-if="currArtifact && currArtifact.attributes" class="sc-artifact-modal-img">
					<img :src="currArtifact.attributes.anteprima">
				</div>
				<div v-if="currArtifact && currArtifact.attributes" class="stack-vertical sc-artifact-modal-contents">
					<div class="stack-vertical sc-artifact-modal-contents-text">
						<div class="capitalize-first font-paragrafo-scrolly font-medium">{{$t('generic_reperto')}}</div>
						<div class="stack-horizontal sc-title-cont">
							<p v-if="currArtifact.attributes.titolo" class="font-paragrafo-scrolly font-medium">{{currArtifact.attributes.titolo}}</p>
						</div>
						<div class="stack-vertical sc-artifact-modal-md">
							<p v-if="currArtifact.attributes.Autore" class="font-paragrafo-scrolly">{{currArtifact.attributes.Autore}}</p>
							<p v-if="currArtifact.attributes.luogo_conservazione" class="font-paragrafo-scrolly">{{currArtifact.attributes.luogo_conservazione}}</p>
							<p v-if="currArtifact.attributes.anno_testo" class="font-paragrafo-scrolly">{{currArtifact.attributes.anno_testo}}</p>
						</div>
					</div>
					<base-button type="variant5" :fit-width="true" :text="utils.capitalizeFirst($t('scrolly_bottone_reperto'))" @clicked="goToBlankArtifact(currArtifact.id)"/>
				</div>
			</div>
		</div>
		<interface-mobile-rem-pt
			v-if="isMobile && currMobileRemarkablePt"
			:visible="currMobileRemarkablePt.visible"
			:title="currMobileRemarkablePt.caption"
			:content="currMobileRemarkablePt.textBefore"
			@close="closeMobileRemarkablePoint"
		/>
		<interface-change-res
			:show-resize-modal="showResizeModal"
		/>
		<div v-show="!showScrolly" class="scrolly-loading-curtain stack-vertical" data-justify="center" data-align="center">
			<base-icon name="loader"/>
		</div>
	</main>
</template>

<script type="text/javascript">
import utils from '@js/utils.js';
import InterfaceMenu from '@components/InterfaceMenu.vue';
import InterfaceSectionContent from '@components/InterfaceSectionContent.vue';
import InterfaceArtifactInfo from '@components/InterfaceArtifactInfo.vue';
import InterfaceAudioPlayer from '@components/InterfaceAudioPlayer.vue';
import InterfaceVideoPlayer from '@components/InterfaceVideoPlayer.vue';
import InterfaceRemarkablePoint from '@components/InterfaceRemarkablePoint.vue';
import InterfaceInDepth from '@components/InterfaceInDepth.vue';
import ScrollEvents from '@components/ScrollEvents.vue';
import InterfaceChangeRes from '@components/InterfaceChangeRes';
import InterfaceProgressBar from '@components/InterfaceProgressBar.vue';
import InterfaceScrollyIntroSection from '@components/InterfaceScrollyIntroSection.vue';
import InterfaceScrollyBibliographySection from '@components/InterfaceScrollyBibliographySection.vue';
import InterfaceMobileRemPt from '@components/InterfaceMobileRemPt.vue'
import InhibitScrollContainer from '@components/InhibitScrollContainer.vue';
import cloneDeep from 'lodash.clonedeep';
import { gsap } from 'gsap/dist/gsap.min.js';
import InterfaceQuoteGame from '@components/InterfaceQuoteGame.vue';
import InterfaceTimeQuizGame from '@components/InterfaceTimeQuizGame.vue';
import InterfaceIntruderGame from '@components/InterfaceIntruderGame.vue';
import ViewGame from '@views/ViewGame.vue';
import gameContents from '@static/dialetti_game_contents.json';
import gameContentsTrivial from '@static/trivial_game_contents_def.json';
import gameContentsIntruder from '@static/intruder_game_contents_def.json';
import { markRaw } from 'vue';

import scrollyMainMixin from '@js/mixins/scrollyMainMixin.js';
import { scrollyMixin } from '@js/mixins/scrollyMixin.js';

export default {
	name: 'ViewMainScrolly',
	components: {
		InterfaceMenu,
		ScrollEvents,
		InterfaceInDepth,
		InterfaceSectionContent,
		InterfaceArtifactInfo,
		InterfaceAudioPlayer,
		InterfaceVideoPlayer,
		InterfaceRemarkablePoint,
		InterfaceChangeRes,
		InterfaceProgressBar,
		InterfaceScrollyIntroSection,
		InterfaceScrollyBibliographySection,
		InterfaceMobileRemPt,
		InhibitScrollContainer,
		ViewGame,
	},
	mixins: [
		scrollyMixin,
		scrollyMainMixin
	],
	data() {
		return {
			scrollyTimelines: [],
			artifactS205: null,
			maps: {},
			// imagesCallback: this.loadSvgImages,
			InterfaceQuoteGame: markRaw(InterfaceQuoteGame),
			InterfaceTimeQuizGame: markRaw(InterfaceTimeQuizGame),
			InterfaceIntruderGame: markRaw(InterfaceIntruderGame),
			gameContents,
			gameContentsTrivial: gameContentsTrivial.questions.filter(el => el.belongsTo == 'Napoli 1'),
			gameContentsIntruder: gameContentsIntruder.questions.filter(el => el.belongsTo == 'Napoli')
		}
	},
	computed: {
		imgQ() { return this.isMobile ? 'low' : 'high'; },
		imageS1_00() {
			return require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s1_00.jpg'))
		},
		mapSVG() {
			return require('@assets/images/percorsi/dialetti/s1_01.svg');
		},
		imageS1_04() {
			return require('@assets/images/percorsi/dialetti/s1_04.svg?url')
		},
		imageS1_05() {
			return require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension(`s1_05_${this.imgQ}.png`))
		},
		imageS1_06() {
			return require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension(`s1_06_${this.imgQ}.png`))
		},
		imageS1_07() {
			return [
				require('@assets/images/percorsi/dialetti/'+/*utils.manageImagesExtension*/(`s1_07_2_${this.imgQ}.png`)),
				require('@assets/images/percorsi/dialetti/'+/*utils.manageImagesExtension*/(`s1_07_1_${this.imgQ}.png`)),
			];
		},
		imageS1_08() {
			return require('@assets/images/percorsi/dialetti/s1_08.svg')
		},
		backgroundS1_08() {
			return require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s1_08_sfondo.png'))
		},
		imageS1_09() {
			return require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension(`s1_09_${this.imgQ}.png`))
		},
		imageS2_02a() {
			return require('@assets/images/percorsi/dialetti/s2_02a.svg')
		},
		imageS2_02b() {
			return require('@assets/images/percorsi/dialetti/s2_02b.svg')
		},
		imageS2_03() {
			return require('@assets/images/percorsi/dialetti/s2_03.svg')
		},
		imageS3_00() {
			return [
				require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s3_00_1.png')),
				require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s3_00_2.png')),
				require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s3_00_3.png')),
			];
		},
		imageS3_02() {
			return [
				require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s3_02_locandina.jpg')),
				require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s3_02_tonino.jpg')),
				require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s3_02_targa.png')),
			];
		},
		imageS3_06() {
			return require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s3_06.png'))
		},
		imageS3_05Dodici() {
			return [
				require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s3_05_dodici_1.png')),
				require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s3_05_dodici_2.png')),
				require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s3_05_dodici_3.png')),
				require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s3_05_dodici_4.png')),
				require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s3_05_dodici_5.png')),
				require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s3_05_dodici_6.png')),
			];
		},
		imageS3_05DodiciComplete() {
			return require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension(`s3_05_dodici_complete_${this.imgQ}.png`))
		},
		imageS3_05Amica() {
			return require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s3_05_amica.jpg'))
		},
		imageS3_05Blinds() {
			return require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s3_05_blinds.jpg'))
		},
		imageS4_00() {
			return require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension(`s4_01_${this.imgQ}.png`))
		},
		imageS4_03() {
			return [
				require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s4_03_1.jpg')),
				require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s4_03_2.jpg')),
			];
		},
		imageS4_04() {
			return {
				fg: require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension(`s4_04_fg_${this.imgQ}.png`)),
				mid: require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension(`s4_04_mid_${this.imgQ}.png`)),
				bg: require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension(`s4_04_bg_${this.imgQ}.jpg`)),
			};
		},
		imageS5_00() {
			return {
				fg: require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension(`s5_06_fg_${this.imgQ}.png`)),
				bg: require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension(`s5_06_bg_${this.imgQ}.jpg`)),
			};
		},
		imageS5_00_full() {
			return require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension(`s5_06_full_${this.imgQ}.jpg`)) 
		},
		imageS5_02() {
			return require('@assets/images/percorsi/dialetti/s5_02.svg');
		},
		imageS5_03() {
			return require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension(`s5_03.jpg`));
		},
		imageS5_04() {
			return [
				require('@assets/images/percorsi/dialetti/s5_04/'+utils.manageImagesExtension('01.png')),
				require('@assets/images/percorsi/dialetti/s5_04/'+utils.manageImagesExtension('02.png')),
				require('@assets/images/percorsi/dialetti/s5_04/'+utils.manageImagesExtension('03.png')),
			];
		},
		imageS5_05() {
			return require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension(`s5_07_${this.imgQ}.jpg`));
		},
		imageS5_06() {
			return require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension(`s5_05_${this.imgQ}.jpg`));
		},
		mobileCbs() {
			// return [this.activateSlider11]
			return [
				() => this.initMobileMap('s1-01'),
				() => this.initMobileMap('s2-02a', this.getSectionById('s2-02').remarkablePoints.filter(p => p.map == 'map-a')),
				() => this.initMobileMap('s2-02b', this.getSectionById('s2-02').remarkablePoints.filter(p => p.map == 'map-b')),
				() => this.initMobileMap('s2-04'),
				() => this.initMobileMap('s5-02'),
			];
		}
	},
	methods: {
		initMobileMap(id, rps) {
			rps = cloneDeep(rps ?? this.getSectionById(id).remarkablePoints);
			const map = document.getElementById(`map-${id}`);
			rps.forEach(rp => { rp.svg = map;  });
			this.maps[id] = {
				navigating: false,
				rps,
				rp: rps[0],
				index: 0,
			};
		},
		navigateMap(id) {
			Object.values(this.maps).forEach(map => {
				if (id == map.id) return;
				map.navigating = false;
			});

			const map = this.maps[id];
			map.navigating = !map.navigating;
			this.toggleMapRP(map.rp, map.navigating);
		},
		cycleMapMobile(id, delta) {
			const map = this.maps[id];

			const lastIndex = map.index;
			let nextIndex = map.index + delta;
			nextIndex = (nextIndex + map.rps.length) % map.rps.length;
			map.index = nextIndex;
			map.rp = map.rps[nextIndex];

			this.toggleMapRP(map.rps[lastIndex], false);
			this.toggleMapRP(map.rps[nextIndex], true);
		},
		imageS1_03(id) {
			return require('@assets/images/percorsi/dialetti/'+utils.manageImagesExtension('s1_03_' + id + `_${this.imgQ}.png`))
		},
		introAnimation() {
			let t1 = this.createTimeline(1)

			let section = this.getSectionById('s1');
			let step1 = this.getSectionById('s1').steps[0];
			let step2 = this.getSectionById('s1').steps[1];

			t1.to('.scrolly-intro-1 .scrolly-title-cont', {transform: 'translate(200%, -50%)'}, 0)
			t1.to('.scrolly-intro-1 .scrolly-intro-image', {transform: 'translate(-150%, 22%) rotate(-90deg)'}, 0)
			t1.to('.scrolly-intro-contents-cont', {transform: 'translate(calc(50vw - var(--menu-size) - 50%), calc(50vh - 50%))'}, 0)

			t1.to('.scrolly-intro-1-image-1', {transform: 'translate(calc(100vw - 130%), calc(100vh - 100%))'}, 0)
			t1.to('.scrolly-intro-1-image-2', {transform: 'translate(0, calc(100vh - 98%)) scale(-1,1)'}, 0)
			t1.to('.scrolly-intro-1-image-3', {transform: 'translate(calc(var(--scrolly-w) * 0.5 - 50%), -71%) rotate(0)'}, 0)

			let t2 = this.createTimeline(0.5)
			t2.to('.scrolly-intro-1', {height: 0})

			step1.enterBackCb = () => {
				t1.reverse()
			}

			step2.enterCb = () => {
				t1.play()
			}

			this.getSectionById('s1').leaveCb = () => {
				t2.play();
			}

			this.getSectionById('s1').enterBackCb = () => {
				t2.reverse();
			}

			t2.eventCallback('onComplete', () => {
				// this.resetInhibitScroll();
				const event = new Event("introfolded");
				window.dispatchEvent(event);
			})

			t2.eventCallback('onReverseComplete', () => {
				// console.log('reverse complete')
				// this.resetInhibitScroll();
				const event = new Event("introfolded");
				window.dispatchEvent(event);
			})

			this.scrollyTimelines['s1'] = [t1, t2]
		},
		mountCustomAnimations() {
			// console.log('sections', cloneDeep(this.sections))
			this.animation1();
			this.animation2();
			this.animation3();
			this.animation4();
			this.animation5();
			this.animation6();
			this.animation7();
			this.animation8();
			this.animation9();
			this.animation20();
			this.animation22();
			this.animation24();
			this.animation30();
			this.animation32();
			this.animation33();
			this.animation34();
			this.animation35();
			this.animation36();
			this.animation40();
			this.animation42();
			this.animation43();
			this.animation44();
			this.animation45();
			this.animation50();
			this.animation52();
			this.animation53();
			this.animation54();
			this.animation55();
			this.animation56();
			this.animationGame();
		},
		animation1() {
			let prefix = '#s1-00';
			let section = this.getSectionById('s1-00');
			let step1 = this.getSectionById('s1-00').steps[0];
			let step2 = this.getSectionById('s1-00').steps[1];
			let step3 = this.getSectionById('s1-00').steps[2];
			let t1 = utils.createTimeline(0.5, {});

			t1.to(`${prefix} .stage-title`, {transform: 'translate(var(--section-left-margin), calc(-50% - 5rem))', opacity: 0}, 0);
			t1.to(`${prefix} .section-side-media`, {opacity: 1, transform: 'translate(calc(var(--scrolly-w) - 100% - var(--section-right-margin)), calc(45vh - 50%)) rotate(9.5deg)'}, 0);
			t1.to(`${prefix} .bg-blue-animated`, {opacity: 1}, 0);
			this.defaultContentAnimation(t1, 's1-00')

			let t2 = utils.createTimeline(0.5, {});
			t2.to(`${prefix} .background-quote`, {opacity: 1, pointerEvents: 'all'}, 0.25)
			t2.to(`${prefix} .section-side-media`, {transform: 'translate(calc(var(--scrolly-w) - 100% - var(--section-right-margin)), calc(60vh - 50%)) rotate(9.5deg)'}, 0);
			t2.to(`${prefix} .scroll-content-section .scroll-content-text`, {transform: `translate(var(--section-left-margin), -15vh)`, opacity: 0, duration: 0.7}, 0)

			section.leaveBackCb = () => {
				t2.pause(0);
				t1.pause(0);
			};
			step2.enterCb = () => {
				t1.play();
			}
			step1.enterBackCb = () => {
				t1.reverse();
			}
			step3.enterCb = () => {
				t2.play();
			}
			step2.enterBackCb = () => {
				t2.reverse();
			}

			this.scrollyTimelines['s1-00'] = [t1, t2];
		},
		animation2() {
			let section = this.getSectionById('s1-01');
			let t1 = utils.createTimeline(1, {});

			this.defaultContentAnimation(t1, 's1-01', 0);
			this.remarkablePointAnimation(t1, 's1-01', 0.5);

			const svg = this.$refs.mapSVG[0];
			const svgBB = svg.firstElementChild.getBoundingClientRect();
			section.remarkablePoints.forEach((rp, i) => {
				rp.svg = svg;
				const path = svg.firstElementChild.getElementById(rp.id.replaceAll(' ', '_'));
				const bb = path.getBoundingClientRect();

				const x = (bb.x + bb.width/2 - svgBB.x) / svgBB.width;
				const y = (bb.y + bb.height/2 - svgBB.y) / svgBB.height;
				rp.posX = rp.posX ?? `${x*100}%`;
				rp.posY = rp.posY ?? `${y*100}%`;

				const id = `s1-01-rp-${i}`;
				path.onmouseenter = () => this.toggleMapRP(rp, true, id);
				path.onmouseleave = () => this.toggleMapRP(rp, false, id);
			});

			section.enterCb = section.enterBackCb = () => {
				t1.play();
			};
			section.leaveBackCb = () => {
				t1.pause(0);
			};

			this.scrollyTimelines['s1-01'] = [t1];
		},
		toggleMapRP(rp, hovered, id) {
			const path = rp.svg.firstElementChild.getElementById(rp.id ?? rp.id.replaceAll(' ', '_'));

			if (rp.stroke)
				path.style.stroke = hovered ? 'var(--color-red)' : null;
			else
				path.style.fill = hovered ? 'var(--color-red)' : null;

			if (id) {
				const rpel = document.getElementById(id);
				rpel.style.zIndex = hovered ? 20 : 1
				const comic = rpel.querySelector('.comic');
				comic.classList.toggle('visible', hovered);
			}
		},
		animation3() {
			let prefix = '#s1-03';
			let section = this.getSectionById('s1-03');

			let t1 = utils.createTimeline(1, {});
			t1.from(`${prefix} .img-1a`, {x: '-80%', ease: 'power1.inOut', duration: 0.65}, 0);
			t1.from(`${prefix} .img-1b`, {x:  '15%', ease: 'power1.inOut', duration: 0.65}, 0);
			t1.from(`${prefix} .img-2a`, {x: '-15%', ease: 'power1.inOut', duration: 0.65}, 0);
			t1.from(`${prefix} .img-2b`, {x:  '90%', ease: 'power1.inOut', duration: 0.65}, 0);
			t1.from(`${prefix} .img-3` , {x:'-100%', ease: 'power1.inOut', duration: 0.65}, 0);
			t1.from(`${prefix} .img-4a`, {x: '-89%', ease: 'power1.inOut', duration: 0.65}, 0);
			t1.from(`${prefix} .img-4b`, {x:  '20%', ease: 'power1.inOut', duration: 0.65}, 0);

			t1.to(`${prefix} .background-gradient`, {transform: 'none'}, 0.75);
			this.defaultContentAnimation(t1, 's1-03', 1);
			this.remarkablePointAnimation(t1, 's1-03', 1.5);

			section.leaveBackCb = () => t1.pause(0);
			section.leaveCb = () => t1.pause(t1.duration());
			section.enterCb = () => t1.play(0);
			this.scrollyTimelines['s1-03'] = [t1]
		},
		animation4() {
			let section = this.getSectionById('s1-04');

			let t1 = utils.createTimeline(0.5, {});
			this.defaultContentAnimation(t1, 's1-04', 0);
			this.remarkablePointAnimation(t1, 's1-04', 1);
			t1.to(`#s1-04 .section-side-media`, {transform: 'translate(calc(var(--scrolly-w) * 0.75 - 50% - var(--section-right-margin)), calc(50vh - 50%)) rotate(20deg)', opacity: 1}, 0);

			section.leaveBackCb = () => t1.pause(0);
			section.leaveCb = () => t1.pause(t1.duration());
			section.enterCb = () => t1.play(0);

			/*
			let step1 = this.getSectionById('s1-04').steps[0];
			let step2 = this.getSectionById('s1-04').steps[1];
			let t2 = utils.createTimeline(0.5, {});
			this.curiosityAnimation(t2, 's1-04', true);

			section.enterCb = () => {
				t1.play();
			};
			step1.enterBackCb = () => {
				t2.reverse();
			};
			step2.enterCb = () => {
				t2.play();
			};
			section.leaveBackCb = () => {
				t1.pause(0);
			};

			this.scrollyTimelines['s1-04'] = [t1, t2];
			*/
			this.scrollyTimelines['s1-04'] = [t1];
		},
		animation5() {
			let section = this.getSectionById('s1-05');

			let t1 = utils.createTimeline(0.5, {});
			t1.to(`#s1-05 .section-side-media`, {transform: 'translate(calc(var(--scrolly-w) - 100% - 10px), calc(50vh - 50%)) rotate(2.82deg)'}, 0);
			t1.pause(0);
			this.defaultContentAnimation(t1, 's1-05', 0.5);
			this.remarkablePointAnimation(t1, 's1-05', 1);

			section.leaveBackCb = () => t1.pause(0);
			section.leaveCb = () => t1.pause(t1.duration());
			section.enterCb = () => t1.play(0);

			this.scrollyTimelines['s1-05'] = [t1];
		},
		animation6() {
			let section = this.getSectionById('s1-06');

			let t1 = utils.createTimeline(0.5, {});
			t1.to(`#s1-06 .section-side-media`, {transform: 'translate(calc(var(--scrolly-w) - 100%), calc(50vh - 50%)) rotate(-5deg)'}, 0);
			this.defaultContentAnimation(t1, 's1-06', 0.5);
			this.remarkablePointAnimation(t1, 's1-06', 1);

			section.leaveBackCb = () => t1.pause(0);
			section.leaveCb = () => t1.pause(t1.duration());
			section.enterCb = () => t1.play(0);

			this.scrollyTimelines['s1-06'] = [t1];
		},
		animation7() {
			let section = this.getSectionById('s1-07');

			let t1 = utils.createTimeline(0.5, {});
			t1.to(`#s1-07 .section-side-media`, {transform: 'translate(calc(var(--scrolly-w) - 100% - var(--section-right-margin)), calc(50vh - 50%)) rotate(0.9deg)'}, 0);
			t1.to(`#s1-07 .section-side-media .img-1`, {transform: 'rotate(-8.5deg)'}, 0.5);
			this.defaultContentAnimation(t1, 's1-07', 0.5);
			this.remarkablePointAnimation(t1, 's1-07', 1);

			section.leaveBackCb = () => t1.pause(0);
			section.leaveCb = () => t1.pause(t1.duration());
			section.enterCb = () => t1.play(0);

			this.scrollyTimelines['s1-07'] = [t1];
		},
		animation8() {
			let section = this.getSectionById('s1-08');

			let t1 = utils.createTimeline(0.5, {});
			t1.to(`#s1-08 .section-side-media`, {transform: 'translate(calc(var(--scrolly-w) - 100% - var(--section-right-margin)), calc(50vh - 50%)) rotate(0.65deg)', opacity: 1}, 0);
			this.defaultContentAnimation(t1, 's1-08', 0.5);
			this.remarkablePointAnimation(t1, 's1-08', 1);

			section.leaveBackCb = () => t1.pause(0);
			section.leaveCb = () => t1.pause(t1.duration());
			section.enterCb = () => t1.play(0);

			this.scrollyTimelines['s1-08'] = [t1];
		},
		animation9() {
			let section = this.getSectionById('s1-09');
			let step1 = section.steps[0];
			let step2 = section.steps[1];

			let t1 = utils.createTimeline(0.5, {});
			t1.to(`#s1-09 .section-side-media`, {transform: 'translate(calc(var(--scrolly-w) - 100% - var(--section-right-margin)), calc(50vh - 50%)) rotate(0)'}, 0);
			this.defaultContentAnimation(t1, 's1-09', 0.5);
			this.remarkablePointAnimation(t1, 's1-09', 1);

			let t2 = utils.createTimeline(0.5, {});
			this.curiosityAnimation(t2, 's1-09', true);

			section.enterCb = () => {
				t1.play();
			};
			step1.enterBackCb = () => {
				t2.reverse();
			};
			step2.enterCb = () => {
				t2.play();
			};
			section.leaveBackCb = () => {
				t1.pause(0);
			};

			// section.leaveCb = section.leaveBackCb = () => t1.pause(0);
			// section.enterCb = section.enterBackCb = () => t1.play(0);

			this.scrollyTimelines['s1-09'] = [t1, t2];
		},
		animation20() {
			let prefix = '#s2-00';
			let section = this.getSectionById('s2-00');
			let step1 = section.steps[0];
			let step2 = section.steps[1];
			let t1 = utils.createTimeline(0.5, {});

			t1.to(`${prefix} .stage-title`, {transform: 'translate(var(--section-left-margin), calc(-50% - 5rem))', opacity: 0}, 0);
			t1.to(`${prefix} .bg-blue-animated`, {opacity: 1}, 0);
			this.defaultContentAnimation(t1, 's2-00')

			section.leaveBackCb = () => {
				t1.pause(0);
			};
			step2.enterCb = () => {
				t1.play();
			}
			step1.enterBackCb = () => {
				t1.reverse();
			}

			this.scrollyTimelines['s2-00'] = [t1];
		},
		animation22() {
			let section = this.getSectionById('s2-02');
			let step1 = section.steps[0];
			let step2 = section.steps[1];

			let t1 = utils.createTimeline(0.5, {});
			this.defaultContentAnimation(t1, 's2-02', 0); 

			t1.set('#s2-02 .remarkable-point-cont.map-b', {opacity: 0, pointerEvents: 'none'}, 0);
			t1.to('#s2-02 .remarkable-point-cont.map-a', {opacity: 1}, 0.5);

			let t2 = utils.createTimeline(0.5, {});
			t2.to(`#s2-02 .map-container-s2-02a`, {opacity: 0, pointerEvents: 'none'}, 0);
			t2.to('#s2-02 .remarkable-point-cont.map-a', {opacity: 0}, 0);

			t2.to(`#s2-02 .map-container-s2-02b`, {opacity: 1, pointerEvents: 'all'}, 0.5);
			t2.to('#s2-02 .remarkable-point-cont.map-b', {opacity: 1}, 0.5);

			section.enterCb = () => t1.play();
			step2.enterCb = () => t2.play();
			step1.enterBackCb = () => t2.reverse();

			section.remarkablePoints.forEach((rp, i) => {
				rp.svg = this.$refs.mapSVG[rp.map == 'map-a' ? 1 : 2];
				// console.log(rp.id, rp.caption.it)
				const path = rp.svg.firstElementChild.getElementById(rp.id ?? rp.caption.it.replaceAll(' ', '_'));
				const bb = path.getBoundingClientRect();
				const svgBB = rp.svg.firstElementChild.getBoundingClientRect();

				const x = (bb.x + bb.width/2 - svgBB.x) / svgBB.width;
				const y = (bb.y + bb.height/2 - svgBB.y) / svgBB.height;
				rp.posX = rp.posX ?? `${x*100}%`;
				rp.posY = rp.posY ?? `${y*100}%`;

				const id = `s2-02-rp-${i}`;
				path.onmouseenter = () => this.toggleMapRP(rp, true, id);
				path.onmouseleave = () => this.toggleMapRP(rp, false, id);
			});

			this.scrollyTimelines['s2-02'] = [t1, t2];
		},
		animation24() {
			let section = this.getSectionById('s2-04');

			let t1 = utils.createTimeline(0.5, {});
			t1.to(`#s2-04 .section-side-media`, {transform: 'translate(calc(var(--scrolly-w) - 100% - var(--section-right-margin)), calc(50vh - 50%))'}, 0);
			this.defaultContentAnimation(t1, 's2-04', 0);
			this.remarkablePointAnimation(t1, 's2-04', 0.5);

			section.leaveBackCb = () => t1.pause(0);
			section.leaveCb = () => t1.pause(t1.duration());
			section.enterCb = () => t1.play(0);

			section.remarkablePoints.forEach((rp, i) => {
				rp.svg = this.$refs.mapSVG[3];
				const path = rp.svg.firstElementChild.getElementById(rp.id ?? rp.caption.it.replaceAll(' ', '_'));
				const bb = path.getBoundingClientRect();
				const svgBB = rp.svg.firstElementChild.getBoundingClientRect();

				const x = (bb.x + bb.width/2 - svgBB.x) / svgBB.width;
				const y = (bb.y + bb.height/2 - svgBB.y) / svgBB.height;
				rp.posX = rp.posX ?? `${x*100}%`;
				rp.posY = rp.posY ?? `${y*100}%`;

				const id = `s2-04-rp-${i}`;
				path.onmouseenter = () => this.toggleMapRP(rp, true, id);
				path.onmouseleave = () => this.toggleMapRP(rp, false, id);
			});

			this.scrollyTimelines['s2-04'] = [t1];
		},
		animation30() {
			let prefix = '#s3-00';
			let section = this.getSectionById('s3-00');
			let step1 = section.steps[0];
			let step2 = section.steps[1];
			let t1 = utils.createTimeline(0.5, {});

			t1.to(`${prefix} .stage-title`, {transform: 'translate(var(--section-left-margin), calc(-50% - 5rem))', opacity: 0}, 0);
			t1.to(`${prefix} .bg-blue-animated`, {opacity: 1}, 0);
			t1.to(`${prefix} div.images`, {opacity: 1}, 0);
			t1.to(`${prefix} .section-side-media.img-1`, {transform: 'translate(calc(var(--scrolly-w) - 190%), calc(50vh - 100%)) rotate(15deg)'}, 0);
			t1.to(`${prefix} .section-side-media.img-2`, {transform: 'translate(calc(var(--scrolly-w) - 135%), calc(50vh - 30%)) rotate(-10deg)'}, 0);
			t1.to(`${prefix} .section-side-media.img-3`, {transform: 'translate(calc(var(--scrolly-w) - 80%), calc(50vh - 0%)) rotate(13deg)'}, 0);
			this.defaultContentAnimation(t1, 's3-00')

			section.leaveBackCb = () => {
				t1.pause(0);
			};
			step2.enterCb = () => {
				t1.play();
			}
			step1.enterBackCb = () => {
				t1.reverse();
			}

			this.scrollyTimelines['s3-00'] = [t1];
		},
		showSingleArtifact(prefix, selector) {
			TweenMax.to(`${prefix} .scrolly-artifact-container:not(${selector}) > *`, 0.5, {opacity: 0}, 0);
			TweenMax.set(`${prefix} .scrolly-artifact-container:not(${selector})`, {pointerEvents: 'none'}, 0);

			const style = window.getComputedStyle(document.querySelector(`${prefix} ${selector} .scrolly-artifact-comic-text`), null);
			const opacity = style.getPropertyValue('opacity');
			if (opacity == 1 || opacity === '100%') return;

			const artifactTextWidth = document.querySelector(`${prefix} .scrolly-artifact-container${selector} .scrolly-artifact-comic-text-content`).getBoundingClientRect().width;
			const singlePadding = parseInt(style.getPropertyValue('padding-right').replace('px', ''));

			TweenMax.set(`${prefix} .scrolly-artifact-container${selector}`, {pointerEvents: 'all'}, 0);
			TweenMax.set(`${prefix} .scrolly-artifact-container${selector} .scrolly-artifact-comic-text`, {width: 0}, 0);
			TweenMax.to(`${prefix} .scrolly-artifact-container${selector} .scrolly-artifact-comic-text`, 0.7, {width: `calc(${artifactTextWidth}px + (${singlePadding}px * 2))`, opacity: 1}, 0.5)
			TweenMax.to(`${prefix} .scrolly-artifact-container${selector} .base-button-rounded`, 0.5, {opacity: 1}, 0.5)
		},
		animation32() {
			let section = this.getSectionById('s3-02');
			let step1 = section.steps[0];
			let step2 = section.steps[1];
			let step3 = section.steps[2];
			let step4 = section.steps[3];

			let t1 = utils.createTimeline(0.5, {});
			this.defaultContentAnimation(t1, 's3-02', 0, false);

			const f0 = () => {
				TweenMax.to('#s3-02 .section-side-media', 0.5, {transform: 'translate(calc(var(--ref-dim) * -0.3), calc(var(--ref-dim) * 0.3))'});
				TweenMax.to('#s3-02 .section-side-media > *', 0.5, {opacity: 0.2});
			};

			const f1 = () => {
				TweenMax.to('#s3-02 .section-side-media', 0.5, {transform: 'translate(calc(var(--ref-dim) * calc(-0.044 - 0.47)), calc(var(--ref-dim) * calc(-0.033 - 0.37*0.5))) rotate(3deg)'});
				TweenMax.to('#s3-02 .section-side-media > *', 0.5, {opacity: 0.2});
				TweenMax.to('#s3-02 .img-locandina', 0.5, {opacity: 1});
				this.showSingleArtifact('#s3-02', '.artifact-1');
			};
			const f2 = () => {
				TweenMax.to('#s3-02 .section-side-media', 0.5, {transform: 'translate(calc(var(--ref-dim) * calc(-0.43 - 0.51)), calc(var(--ref-dim) * calc(-0.3 - 0.51*0.5))) rotate(-5deg)'});
				TweenMax.to('#s3-02 .section-side-media > *', 0.5, {opacity: 0.2});
				TweenMax.to('#s3-02 .img-tonino', 0.5, {opacity: 1});
				this.showSingleArtifact('#s3-02', '.artifact-2');
			};

			const f3 = () => {
				TweenMax.to('#s3-02 .section-side-media', 0.5, {transform: 'translate(calc(var(--ref-dim) * calc(-0.024 - 0.5)), calc(var(--ref-dim) * calc(-0.56 - 0.4*0.5))) rotate(3deg)'});
				TweenMax.to('#s3-02 .section-side-media > *', 0.5, {opacity: 0.2});
				TweenMax.to('#s3-02 .img-targa', 0.5, {opacity: 1});
				this.showSingleArtifact('#s3-02', '.artifact-3');
			};

			let t4 = utils.createTimeline(0.5, {});
			this.curiosityAnimation(t4, 's3-02', true);

			let tFake = utils.createTimeline(0.5, {});
			tFake.to('#s3-02 .section-side-media', {transform: 'translate(calc(var(--ref-dim) * calc(-0.024 - 0.5)), calc(var(--ref-dim) * calc(-0.56 - 0.4*0.5))) rotate(3deg)'}, 0);
			tFake.to('#s3-02 .section-side-media > *', {opacity: 0.2}, 0);
			tFake.to('#s3-02 .img-targa', {opacity: 1}, 0);

			section.enterCb = () => {
				t1.play(); f1();
			};
			step1.enterBackCb = f1;
			step2.enterCb = step2.enterBackCb = f2;
			step3.enterCb = f3;

			step3.enterBackCb = () => t4.reverse();
			step4.enterCb = () => t4.play();
			section.leaveBackCb = () => {
				t1.pause(0); f0();
			};

			this.scrollyTimelines['s3-02'] = [t1, t4, tFake];
		},
		animation33() {
			let section = this.getSectionById('s3-03');

			let t1 = utils.createTimeline(0.5, {});
			t1.to(`#s3-03 .section-side-media`, {transform: 'translate(calc(var(--scrolly-w) - 100% - var(--section-right-margin)), calc(50vh - 50%))'}, 0);
			this.defaultContentAnimation(t1, 's3-03', 0);
			this.remarkablePointAnimation(t1, 's3-03', 0.5);

			section.leaveBackCb = () => t1.pause(0);
			section.leaveCb = () => t1.pause(t1.duration());
			section.enterCb = () => t1.play(0);

			this.scrollyTimelines['s3-03'] = [t1];
		},
		animation34() {
			const prefix = '#s3-04';
			let section = this.getSectionById('s3-04');

			let t1 = utils.createTimeline(0.5, {});
			t1.to(`${prefix} .background-gradient`, {transform: 'translate(0,0)'}, 0)
			this.defaultContentAnimation(t1, 's3-04', 0.5);

			section.leaveBackCb = () => t1.pause(0);
			section.leaveCb = () => t1.pause(t1.duration());
			section.enterCb = () => t1.play(0);

			this.scrollyTimelines['s3-04'] = [t1];
		},
		animation35() {
			const prefix = '#s3-05';
			let section = this.getSectionById('s3-05');
			let step1 = section.steps[0];
			let step2 = section.steps[1];

			let t1 = utils.createTimeline(0.5, {});
			t1.to(`${prefix} .dodici`, {opacity: 1}, 0);
			this.defaultContentAnimation(t1, 's3-05', 0, false);

			let t2 = utils.createTimeline(0.5, {});
			t2.to(`${prefix} .scrollable-cont`, {transform: 'translate(0, -100vh)'}, 0)
			t2.to(`${prefix} .background-gradient`, {transform: 'translate(0,0)'}, 0)
			t2.from(`${prefix} .button-base`, {translate: '0 20px', opacity: 0, pointerEvents: 'none'}, 0)

			let dynamic = utils.createTimeline(1, {});
			dynamic.from(`${prefix} .blinds`, {translate: '0 -100%', duration: 1}, 0)
			dynamic.to(`${prefix} .button-base`, {translate: '0 20px', opacity: 0, pointerEvents: 'none', duration: 1}, 0)
			this.remarkablePointAnimation(dynamic, 's3-05', 0);

			for (let i = 1; i <= 6; i++) {
				const sel = `#s3-05 .dodici-image.img-${i}`;
				const randomTween = (from, to) => {
					const m = 8;
					const M = 15;
					const duration = m + Math.random() * (M - m);
					if (Math.random() < 0.5) [from, to] = [to, from];
					gsap.fromTo(sel, from, { ...to, duration,  repeat: -1, yoyo: true, ease: "power1.inOut" })
						.progress(Math.random());
				};
				randomTween({y: "0.5%"} , {y: "-0.5%"})
				randomTween({x: "1%"} , {x: "-1%"})
				randomTween({rotation: -3} , {rotation: 3})
			}

			section.enterCb = () => {
				t1.play(0);
				this.showSingleArtifact(prefix, '.artifact-1');
				this.artifactS205 = '.artifact-1';
			}

			section.leaveBackCb = () => {
				t1.pause(0);
				section.rewindCb();
				this.showSingleArtifact(prefix, '.artifact-1');
				this.artifactS205 = '.artifact-1';
			};
			step2.enterCb = () => {
				t2.play();
				this.showSingleArtifact(prefix, '.artifact-2');
				this.artifactS205 = '.artifact-2';
			}
			step1.enterBackCb = () => {
				t2.reverse();
				this.showSingleArtifact(prefix, '.artifact-1');
				this.artifactS205 = '.artifact-1';
			}

			section.leaveCb = () => {
				t1.pause(t1.duration());
				section.fastforwardCb();
			};

			section.rewindCb = () => {
				this.$refs.scrollS3_05Cont[0].toStart();
				this.$refs.scrollS3_05Cont[1].toStart();
				this.showSingleArtifact(prefix, '.artifact-1');
				this.artifactS205 = '.artifact-1';
			};
			section.fastforwardCb = () => {
				this.$refs.scrollS3_05Cont[0].toEnd();
				this.$refs.scrollS3_05Cont[1].toEnd();
				this.showSingleArtifact(prefix, '.artifact-3');
				this.artifactS205 = '.artifact-3';
			};

			this.scrollyTimelines['s3-05'] = [t1, t2, dynamic];
		},
		scrollS2_05(data) {
			if (!this.scrollyTimelines['s3-05']) return;
			this.scrollyTimelines['s3-05'][2].pause(data.progress);

			const art = data.progress > 0.5 ? '.artifact-3' : '.artifact-2';
			if (this.artifactS205 != art && this.artifactS205 !== '.artifact-1') {
				this.showSingleArtifact('#s3-05', art);
				this.artifactS205 = art;
			}
		},
		animation36() {
			const prefix = '#s3-06';
			let section = this.getSectionById('s3-06');

			let t1 = utils.createTimeline(0.5, {});
			t1.to(`${prefix} .section-side-media`, {transform: 'translate(calc(var(--scrolly-w) - 100% - var(--section-right-margin)), calc(50vh - 50%))'}, 0);
			this.defaultContentAnimation(t1, 's3-06', 0.5);

			section.leaveBackCb = () => t1.pause(0);
			section.leaveCb = () => t1.pause(t1.duration());
			section.enterCb = () => t1.play(0);

			this.scrollyTimelines['s3-06'] = [t1];
		},
		animation40() {
			let prefix = '#s4-00';
			let section = this.getSectionById('s4-00');
			let step1 = section.steps[0];
			let step2 = section.steps[1];
			let t1 = utils.createTimeline(0.5, {});

			t1.to(`${prefix} .stage-title`, {transform: 'translate(var(--section-left-margin), calc(-50% - 5rem))', opacity: 0}, 0);
			t1.to(`${prefix} .bg-blue-animated`, {opacity: 1}, 0);
			t1.to(`${prefix} .section-side-media`, {transform: 'translate(calc(var(--scrolly-w) - var(--max-media-width)), -2%) rotate(-9deg)', opacity: 1}, 0);
			this.defaultContentAnimation(t1, 's4-00')

			section.leaveBackCb = () => {
				t1.pause(0);
			};
			step2.enterCb = () => {
				t1.play();
			}
			step1.enterBackCb = () => {
				t1.reverse();
			}

			this.scrollyTimelines['s4-00'] = [t1];
		},
		animation42() {
			const prefix = '#s4-02';
			let section = this.getSectionById('s4-02');
			let step1 = section.steps[0];
			let step2 = section.steps[1];

			let t1 = utils.createTimeline(0.5, {});
			this.defaultContentAnimation(t1, 's4-02', 0.5, false);

			let t2 = utils.createTimeline(0.5, {});
			t2.to(`${prefix} .section-animation-cont`, 0.5, {transform: 'translate(calc(var(--u) * -0.3), calc(var(--u) * -1.5)) rotate(-14deg)'}, 0);
			t2.to(`${prefix} .section-animation-cont video`, 0.5, {opacity: 0.3}, 0);
			t2.to(`${prefix} .section-animation-cont video:last-child`, 0.5, {opacity: 1}, 0);

			const pauseVideos = () => Array.from(document.querySelectorAll(`${prefix} .section-animation-cont video`)).forEach(v => v.pause());

			section.leaveBackCb = () => {
				TweenMax.set(`${prefix} .section-animation-cont`, {transform: 'translate(calc(var(--u) * 1), calc(var(--u) * 1)) rotate(-15deg)'});
				t1.pause(0);
				pauseVideos();
			};
			step1.enterBackCb = section.enterCb = () => {
				TweenMax.to(`${prefix} .section-animation-cont`, 0.5, {transform: 'translate(calc(var(--u) * -0.57), calc(var(--u) * -0.74)) rotate(3.5deg)'});
				TweenMax.to(`${prefix} .section-animation-cont video`, 0.5, {opacity: 0.2});
				TweenMax.to(`${prefix} .section-animation-cont video:first-child`, 0.5, {opacity: 1});
				pauseVideos();
				this.showSingleArtifact(prefix, '.artifact-1');
			};
			section.enterCb = () => { step1.enterBackCb(); t1.play(0); }
			section.enterBackCb = step2.enterCb = () => {
				TweenMax.to(`${prefix} .section-animation-cont`, 0.5, {transform: 'translate(calc(var(--u) * -0.3), calc(var(--u) * -1.5)) rotate(-14deg)'});
				TweenMax.to(`${prefix} .section-animation-cont video`, 0.5, {opacity: 0.2});
				TweenMax.to(`${prefix} .section-animation-cont video:last-child`, 0.5, {opacity: 1});
				pauseVideos();
				this.showSingleArtifact(prefix, '.artifact-2');
			};
			section.leaveCb = pauseVideos;

			this.scrollyTimelines['s4-02'] = [t1, t2];
		},
		animation43() {
			const prefix = '#s4-03';
			let section = this.getSectionById('s4-03');
			let step1 = section.steps[0];
			let step2 = section.steps[1];
			let step3 = section.steps[2];

			let t1 = utils.createTimeline(0.5, {});
			this.defaultContentAnimation(t1, 's4-03', 0.5, false);

			let t2 = utils.createTimeline(0.5, {});
			t2.to(`${prefix} .section-animation-cont`, 0.5, {transform: 'translate(calc(var(--u) * -0.3), calc(var(--u) * -2)) rotate(-2deg)'}, 0);
			t2.to(`${prefix} .section-animation-cont *`, 0.5, {opacity: 0.3}, 0);
			t2.to(`${prefix} .section-animation-cont :last-child`, 0.5, {opacity: 1}, 0);

			const pauseVideos = () => Array.from(document.querySelectorAll(`${prefix} .section-animation-cont video`)).forEach(v => v.pause());

			section.leaveBackCb = () => {
				TweenMax.set(`${prefix} .section-animation-cont`, {transform: 'translate(calc(var(--u) * 0.5), calc(var(--u)*1))'});
				t1.pause(0);
				pauseVideos();
			};

			step1.enterBackCb = section.enterCb = () => {
				TweenMax.to(`${prefix} .section-animation-cont`, 0.5, {transform: 'translate(calc(var(--u) * 0.1), calc(var(--u) * -0.35)) rotate(-7deg)'});
				TweenMax.to(`${prefix} .section-animation-cont *`, 0.5, {opacity: 0.2});
				TweenMax.to(`${prefix} .section-animation-cont :first-child`, 0.5, {opacity: 1});
				this.showSingleArtifact(prefix, '.artifact-1');
				pauseVideos();
			};
			section.enterCb = () => { step1.enterBackCb(); t1.play(0); }
			step2.enterBackCb = step2.enterCb = () => {
				TweenMax.to(`${prefix} .section-animation-cont`, 0.5, {transform: 'translate(calc(var(--u) * -0.1), calc(var(--u) * -1.2)) rotate(17deg)'});
				TweenMax.to(`${prefix} .section-animation-cont *`, 0.5, {opacity: 0.2});
				TweenMax.to(`${prefix} .section-animation-cont :nth-child(2)`, 0.5, {opacity: 1});
				this.showSingleArtifact(prefix, '.artifact-2');
				pauseVideos();
			};
			section.enterBackCb = step3.enterCb = () => {
				TweenMax.to(`${prefix} .section-animation-cont`, 0.5, {transform: 'translate(calc(var(--u) * -0.3), calc(var(--u) * -2)) rotate(-2deg)'});
				TweenMax.to(`${prefix} .section-animation-cont *`, 0.5, {opacity: 0.2});
				TweenMax.to(`${prefix} .section-animation-cont :last-child`, 0.5, {opacity: 1});
				this.showSingleArtifact(prefix, '.artifact-3');
				pauseVideos();
			};
			section.leaveCb = pauseVideos;

			this.scrollyTimelines['s4-03'] = [t1, t2];
		},
		animation44() {
			const prefix = '#s4-04';
			let section = this.getSectionById('s4-04');

			let t1 = utils.createTimeline(0.5, {});
			t1.to(`${prefix} .bg`, {duration: 1, transform: 'translateY(0)', ease: 'sine.inOut'}, 0);
			t1.to(`${prefix} .fg`, {duration: 1, transform: 'translateY(0)', ease: 'sine.inOut'}, 0);
			t1.to(`${prefix} .background-gradient`, {transform: 'translate(0,0)'}, 1)
			this.defaultContentAnimation(t1, 's4-04', 1.5);

			section.leaveBackCb = () => t1.pause(0);
			section.enterCb = () => t1.play(0);
			section.leaveCb = () => t1.pause(t1.duration());

			this.scrollyTimelines['s4-04'] = [t1];
		},
		animation45() {
			const prefix = '#s4-05';
			let section = this.getSectionById('s4-05');
			let step1 = section.steps[0];
			let step2 = section.steps[1];

			let t2 = utils.createTimeline(0.5, {});
			this.curiosityAnimation(t2, 's4-05', true);

			let t1 = utils.createTimeline(0.5, {});
			t1.to(`${prefix} .section-side-media`, {transform: 'translate(calc(var(--scrolly-w) - 100% - var(--section-right-margin)), calc(50vh - 50%))'}, 0);
			t1.to(`${prefix} .background-gradient`, {transform: 'translate(0,0)'}, 0)
			this.defaultContentAnimation(t1, 's4-05', 0.5);

			section.enterCb = () => t1.play();
			step2.enterCb = () => t2.play();
			step1.enterBackCb = () => t2.reverse();
			section.leaveBackCb = () => t1.pause(0);
			section.leaveCb = () => { t1.pause(t1.duration()); t2.pause(t2.duration()); };

			this.scrollyTimelines['s4-05'] = [t1, t2];
		},
		animation50() {
			let prefix = '#s5-00';
			let section = this.getSectionById('s5-00');
			let step1 = section.steps[0];
			let step2 = section.steps[1];
			let t1 = utils.createTimeline(0.5, {});

			t1.to(`${prefix} .stage-title`, {transform: 'translate(var(--section-left-margin), calc(-50% - 5rem))', opacity: 0}, 0);
			t1.to(`${prefix} .section-bg-cont`, {transform: 'none', opacity: 1}, 0);
			t1.to(`${prefix} .section-side-media`, {transform: 'translate(calc(var(--scrolly-w) - var(--max-media-width)), -2%) rotate(-9deg)', opacity: 1}, 0);
			t1.to(`${prefix} .background-blue`, {opacity: 0}, 0);
			this.defaultContentAnimation(t1, 's5-00', 0)

			// // t1.to(`${prefix} .bg`, {duration: 1, transform: 'translateY(40px)', ease: 'sine.inOut'}, 1);

			section.leaveBackCb = () => {
				t1.pause(0);
			};
			step2.enterCb = () => {
				t1.play();
			}
			step1.enterBackCb = () => {
				t1.reverse();
			}

			this.scrollyTimelines['s3-00'] = [t1];
		},
		animation52() {
			const prefix = '#s5-02';
			let section = this.getSectionById('s5-02');
			let step1 = section.steps[0];
			let step2 = section.steps[1];

			let t1 = utils.createTimeline(0.5, {});
			this.defaultContentAnimation(t1, 's5-02', 0.5);
			this.remarkablePointAnimation(t1, 's5-02', 0.5);

			let t2 = utils.createTimeline(0.5, {});
			this.curiosityAnimation(t2, 's5-02', true);

			section.remarkablePoints.forEach((rp, i) => {
				rp.svg = this.$refs.mapSVG[4];
				const path = rp.svg.firstElementChild.getElementById(rp.id ?? rp.caption.replaceAll(' ', '_'));
				const bb = path.getBoundingClientRect();
				const svgBB = rp.svg.firstElementChild.getBoundingClientRect();

				const x = (bb.x + bb.width/2 - svgBB.x) / svgBB.width;
				const y = (bb.y + bb.height/2 - svgBB.y) / svgBB.height;
				rp.posX = rp.posX ?? `${x*100}%`;
				rp.posY = rp.posY ?? `${y*100}%`;

				const id = `s5-02-rp-${i}`;
				path.onmouseenter = () => this.toggleMapRP(rp, true, id);
				path.onmouseleave = () => this.toggleMapRP(rp, false, id);
			});

			section.leaveBackCb = () => t1.pause(0);
			section.leaveCb = () => { t1.pause(t1.duration()); t2.pause(t2.duration()); };
			section.enterCb = () => t1.play();
			step1.enterBackCb = () => t2.reverse();
			step2.enterCb = () => t2.play();

			this.scrollyTimelines['s5-02'] = [t1];
		},
		animation53() {
			const prefix = '#s5-03';
			let section = this.getSectionById('s5-03');

			let t1 = utils.createTimeline(0.5, {});
			t1.to(`${prefix} .section-side-media`, {transform: 'translate(calc(var(--scrolly-w) - 100%), calc(55vh - 50%)) rotate(-15deg)'}, 0);
			this.defaultContentAnimation(t1, 's5-03', 0.5);

			section.leaveBackCb = () => t1.pause(0);
			section.leaveCb = () => t1.pause(t1.duration());
			section.enterCb = () => t1.play(0);

			this.scrollyTimelines['s5-03'] = [t1];
		},
		animation54() {
			const prefix = '#s5-04';
			let section = this.getSectionById('s5-04');

			let t1 = utils.createTimeline(0.5, {});
			t1.to(`${prefix} .section-side-media.img-1`, {transform: 'translate(calc(var(--scrolly-w) - 120% - var(--section-right-margin)), calc(50vh - 90%)) rotate(-12deg)'}, 0);
			t1.to(`${prefix} .section-side-media.img-2`, {transform: 'translate(calc(var(--scrolly-w) - 115% - var(--section-right-margin)), calc(100vh - 75%)) rotate(13deg)'}, 0);
			t1.to(`${prefix} .section-side-media.img-3`, {transform: 'translate(calc(var(--scrolly-w) - 100%), calc(50vh - 50%)) rotate(31deg)'}, 0);
			this.defaultContentAnimation(t1, 's5-04', 0.5);

			section.leaveBackCb = () => t1.pause(0);
			section.leaveCb = () => t1.pause(t1.duration());
			section.enterCb = () => t1.play(0);

			this.scrollyTimelines['s5-04'] = [t1];
		},
		animation55() {
			const prefix = '#s5-05';
			let section = this.getSectionById('s5-05');

			let t1 = utils.createTimeline(0.5, {});
			t1.to(`${prefix} .section-side-media`, {transform: 'translate(calc(var(--scrolly-w) - 100%), calc(55vh - 50%)) rotate(-10deg)'}, 0);
			t1.to(`${prefix} .background-gradient`, {transform: 'translate(0,0)'}, 1)
			this.defaultContentAnimation(t1, 's5-05', 1.5);

			section.leaveBackCb = () => t1.pause(0);
			section.leaveCb = () => t1.pause(t1.duration());
			section.enterCb = () => t1.play(0);

			this.scrollyTimelines['s5-05'] = [t1];
		},
		animation56() {
			const prefix = '#s5-06';
			let section = this.getSectionById('s5-06');

			let t1 = utils.createTimeline(0.5, {});
			t1.to(`${prefix} .section-side-media`, {transform: 'translate(calc(var(--scrolly-w) - 100% - var(--section-right-margin)), calc(50vh - 50%)) rotate(-5deg)'}, 0);
			this.defaultContentAnimation(t1, 's5-06', 0.5);

			section.leaveBackCb = () => t1.pause(0);
			section.leaveCb = () => t1.pause(t1.duration());
			section.enterCb = () => t1.play(0);

			this.scrollyTimelines['s5-06'] = [t1];
		},
		animationGame()  {
			this.sections.filter(s => s.id.endsWith('-game')).forEach(section => {
				let t1 = utils.createTimeline(0.5, {});
				t1.to('.scroll-progress-cont', {opacity: 0, pointerEvents: 'none'}, 0)

				section.leaveCb = section.leaveBackCb = () => t1.pause(0);
				section.enterCb = section.enterBackCb = () => t1.play();

				this.scrollyTimelines[section.id] = [t1]
			});
		},
	},
}
</script>

<style lang="scss" src="@css/views/ViewScrolly.scss">
</style>

<style lang="scss">
@import '@css/variables.scss';

.remarkable-point-cont.remarkable-point-thin {
	transform: translate(-12px, -12px);
}
.remarkable-point-cont.remarkable-point-thin .remarkable-spot {
	transform: scale(0.7);
}
.remarkable-point-cont.remarkable-point-thin .remarkable-point-text {
	padding: 0.5rem 1rem;
}

.scrolly-dialetti {
	.section-cont {
		--max-media-width: calc(var(--scrolly-w) - 34rem - 2 * var(--section-right-margin));
		--max-media-width-tight: calc(var(--scrolly-w) - 36rem - var(--section-right-margin));
	}

	.map-container {
		--map-u: calc(max(var(--scrolly-w) / 16, 100vh / 9));

		position: absolute;
		top: 50%;
		right: 0;
		transform: translate(0, -50%);

		width: calc(var(--map-u) * 16);
		height: calc(var(--map-u) * 9);

		.remarkable-point-cont {
			pointer-events: none;
    }
	}

	.map-container svg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}

	.scrolly-intro-1-image-1 {
		height: 60vh;
		transform: translate(calc(100vw + 100%), calc(100vh - 20%));
	}

	.scrolly-intro-1-image-2 {
		height: 50vh;
		transform: translate(-200%, calc(100vh - 98%)) scale(-1,1);
	}

	.scrolly-intro-1-image-3 {
		height: 50vw;
		transform-origin: center;
		transform: translate(calc(var(--scrolly-w) * 0.5 - 50%), -150%) rotate(-170deg);
	}

	#s1-03 .sliding-image {
		min-height: 100%;
		min-width: 100%;
		transform: translateY(calc(50vh - 50%));
	}
	#s1-03 .sliding-image.mobile {
		transform: none;
		top: 0;
	}

	#s2-04 .remarkable-spot {
		display: none;
	}

	#s3-00 ul,
	.in-depth-item-contents ul {
		list-style: disc;
		padding-left: 1.5em;
	}

	#s3-02 {
		--ref-dim: min(calc(var(--max-media-width) * 1.8), 160vh);
	}

	#s3-02 .section-side-media {
		width: var(--ref-dim);
		height: var(--ref-dim);
		left: calc(100% - var(--ref-dim) / 2);
		top: 50vh;
		left: calc(var(--scrolly-w) - var(--section-left-margin));
	}
	#s3-02 .section-side-media > div {
		opacity: 0.2;
	}

	#s3-05 .dodici {
		opacity: 0;
	}
	#s3-05 .dodici-image {
		top: 15px;
		right: 18px;
		max-height: 150vh;
		max-width: var(--max-media-width-tight);
		object-fit: contain;
	}

	#s3-05 .scrollable-cont {
		position: relative;
		width: calc(var(--scrolly-w) + 18px);
		height: 100vh;
		overflow-y: scroll;
		overflow-x: hidden;
	}
	#s3-05 .amica,
	#s3-05 .blinds {
		position: sticky;
		width: 100%;
		height: 100%;
		object-fit: cover;
		pointer-events: none;
	}
	#s3-05 .scroll-content-section {
		pointer-events: none;
	}
	#s3-05 .scroll-content-section .button-base {
		pointer-events: all;
	}

	#s4-04 .section-animation-cont {
		--diorama-u: calc(max(var(--scrolly-w) / 2657, 100vh / 1759));

		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		width: calc(var(--diorama-u) * 2657);
		height: calc(var(--diorama-u) * 1759);

		.bg, .mid, .fg {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
		}
	}

	#s4-04 .section-animation-cont-mobile {
		position: relative;
		overflow: hidden;

		img {
			width: 200vw;
			max-width: none;
			transform: translate(-22%, 0);
		}

		.bg {
			position: absolute;
			top: 0;
		}
	}

	#s4-02 .section-animation-cont,
	#s4-03 .section-animation-cont {
		--u: calc(min(var(--max-media-width) * 0.82, 80vh));

		width: calc(1.6 * var(--u));
		height: calc(2.45 * var(--u));

		position: absolute;
		top: calc(50vh - var(--u) * 0.3);
		right: calc(var(--u) * -0.67 + var(--section-right-margin));

		video, img {
			position: absolute;
			top: 0;
			left: 0;
			object-fit: cover;

			border: var(--s0) solid var(--color-white);
			border-radius: var(--s1);
			background: var(--color-white);
		}

		video, .size-video {
			width: var(--u);
			height: calc(0.563 * var(--u));
		}
	}

	#s5-00 .section-bg-cont {
		position: absolute;
		left: 0; top: 0; right: 0; bottom: 0;

		.bg, .fg {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	#s5-00 img {
		height: 120vh;
	}

	.mobile-map svg {
		margin-left: -115%;
	}

	.map-navigator {
		background: var(--color-white);
		padding: 0.5rem 0 0.5rem;
		gap: 0.5rem;

		.map-navigator-selector {
			width: 100%;
			align-items: center;
		}

		.text {
			line-height: 130%;
			text-align: center;
		}
	}

	.scrolly-section-mobile-cont .button-base {
		margin: auto;
	}

	#s5-00 .section-animation-cont-mobile {
		position: relative;
		width: 100vw;
		height: 150vw;
		overflow: hidden;

		img {
	    position: absolute;
	    left: 0; top: 0; right: 0; bottom: 0;
	    object-fit: contain;
	    object-position: center;
		}
	}

	.white-border-thick {
		border-radius: var(--s3);
		border: var(--s2) solid var(--color-white);
	}

	.white-border-thin {
		border: solid 0.325rem var(--color-white);
	}

	tt {
		font-family: inherit;
		font-variant: small-caps;
	}

	.section-cont {
		overflow: hidden;
	}

	.background-img,
	.background-video {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		background: var(--color-black);
	}

	.section-cont div.section-side-media > svg {
		width: 100%;
		height: 100%;
	}

	@media (max-width: $breakpoint-sm) {
		.scrolly-section-mobile-cont {
			> img, > video {
			 width: 100%;
			}
		}

		.scrolly-section-mobile-cont:not(.stage-start) {
			padding-top: 2rem;

			&.no-space {
				padding-top: 0;
			}
		}
	}

	.mobile-fullw {
		position: relative;
		margin: 0 -1.25rem;
		max-width: none;

		img, video {
			max-width: none;
			width: 100%;
		}
	}

  .mobile-map-container {
		margin-bottom: 1.5rem;
	}

  img.mobile-fullw, video.mobile-fullw {
		width: 100vw;
	}

	.roll-in {
		transform: translateX(100vw) rotate(179deg);
		transition: transform 0.5s;
	}
	.visible .roll-in {
		transform: none;
	}
}
</style>
